import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Simple inline resources to start; move to separate JSON files later.
const resources = {
  en: {
    common: {
      countries: {
  france: "France",
  spain: "Spain",
  united_states: "United States",
  switzerland: "Switzerland",
  germany: "Germany",
  italy: "Italy",
  australia: "Australia",
  croatia: "Croatia",
  chile: "Chile",
},
      app_title: "A Global Network for Wine Business & Economics",
      landing: {
        explore: "Explore",
        join: "Join",
        explore_observatory: "Explore the Observatory",
        sign_in: "Sign in",
        welcome_back: "Welcome back to the institute.",
        inside_network: "Inside the network",
        everything: "Everything the institute brings together.",
        live_community: "Live from the community",
        newswire: "Wine newswire",
        latest_journals: "Latest from the journals",
        upcoming: "Upcoming",
        vw_eyebrow: "Visualising Wine — for policymakers, industry & academics",
        vw_heading: "Explore the data, read the climate stories, compare any country.",
        vw_sub: "An evidence base built for policymakers, companies and academics — descriptive, sourced and citable.",
        vw_card1_tag: "Explore",
        vw_card1_title: "The interactive Atlas",
        vw_card1_desc: "Every winery on one map — by climate, variety, exports, terroir and more.",
        vw_card2_tag: "Story",
        vw_card2_title: "Three decades of warming",
        vw_card2_desc: "Scroll and watch 5,106 vineyards warm between the 1980s and today.",
        vw_card3_tag: "Tool",
        vw_card3_title: "Country Portrait",
        vw_card3_desc: "Pick a country and compare it vs. peers, head to head.",
        explore_data: "Explore the data",
        data_heading: "The first global, firm-level picture of how the world makes wine.",
        data_sub: "21 wine-producing countries, surveyed winery by winery — exports, organic share, premiumisation and climate. Preview a few below, or open the interactive atlas.",
        map_alt: "The 21 wine-survey countries",
        map_text: "All 21 wine-producing countries on one interactive map — shade by exports, organic share, premiumisation or climate and drill into any country.",
        open_atlas: "Open the interactive atlas",
        country_portrait: "Country portrait",
        gate_text: "Previewing {{n}} of {{total}} countries — create a free account to unlock every country portrait, head-to-head comparisons and the full research tools.",
        gate_cta: "Create a free account",
        no_account: "New here?",
        verify_checking: "Confirming your email…",
        verify_ok_title: "Email confirmed",
        verify_ok_desc: "Your email is verified. You can now sign in to your account.",
        verify_bad_title: "Link invalid or expired",
        verify_bad_desc: "This verification link is invalid or has expired. Sign in to request a new one.",
        verify_back: "Back to sign in",
        join_institute: "Join the institute",
        join_blurb: "Connect with researchers, companies and policymakers worldwide — bring a question, run the research tools, and join seminars across the global wine community. We maintain the survey; members simply answer it.",
        create_free: "Create a free account",
        see_all: "See all",
        more_platform: "More on the platform",
        all_events: "All events",

watch_story: "What is the GWBI?",
founding_members: "Founding Members",
founding_members_heading:
  "The institutions behind the Global Wine Business Institute.",
founding_members_desc:
  "The GWBI was founded through the collaboration of universities and research institutions from across the global wine community.",
founding_institutions: "Founding Institutions",
visit_institution: "Visit institution",
},
      beta_banner:
        "Beta: This platform is under active development. Features may change.",
      login: "Enter",
      register: "Register",
      email: "Email",
      password: "Password",
      remember_me: "Remember Me",
      forgot_password: "Forgot Password?",
      create_account_cta: "Create Free Account",
      news: "News",
      conferences: "Events",
      research: "Research",
      insights: "Insights",
      get_started: "Get Started",
      see_details: "See Details",
      reset_title: "Reset your password",
      reset_desc: "Enter your email. If it exists, we'll send a reset link.",
      send_reset: "Send reset link",
      cancel: "Cancel",
      reg_tagline:
        "Where Wine Meets Knowledge — Connect, Share, and Grow in the Global Wine Business.",
      reg_create_account: "Create your account",
      reg_join: "Join the global wine community",
      reg_first_name: "First name",
      reg_last_name: "Last name",
      reg_user_type: "User type",
      reg_user_type_researcher: "Academic / Researcher",
      reg_user_type_student: "Student",
      reg_user_type_industry: "Industry Professional",
      industry_categories: {
        grape_grower: "Grape Grower",
        wineries: "Wineries",
        distributors: "Distributors",
        retailers: "Retailers",
        supply_chain_partners: "Supply Chain Partners",
        hospitality: "Hospitality Sector (restaurant, bar, hotels…)",
        media_journalism: "Media & Journalism",
        wine_educators: "Wine Educators (Sommelier, wine tasters…)",
      },
      winery_roles: {
        owner: "Owner",
        winemaker: "Winemaker",
        assistant_winemaker: "Assistant Winemaker",
        enologist: "Enologist",
        vineyard_manager: "Vineyard Manager",
        agronomist: "Agronomist",
        cellar_master: "Cellar Master",
        operations_director: "Operations Director",
        sales_manager: "Sales Manager",
        pr_manager: "PR Manager",
        marketing_manager: "Marketing Manager",
        other_complete: "Other (complete)",
      },
      reg_user_type_policy: "Policymaker & Public Official",
      reg_user_type_enthusiast: "Enthusiast",
      reg_user_type_other: "Other",
      reg_other_specify: "Please specify",
      reg_account_kind: "Who is this profile for?",
      reg_account_kind_individual: "Me — a person",
      reg_account_kind_individual_hint:
        "Your profile carries your own name and is listed under People. Your university or employer still appears on your card — choose this even if you are registering from a work address.",
      reg_account_kind_organization: "An institution or company I represent",
      reg_account_kind_organization_hint:
        "The profile carries the organisation's name and logo and is listed publicly as an institution. Choose this only if you are creating the organisation's own page.",
      reg_org_heading: "Your organisation",
      reg_org_optional_hint: "Optional — it helps us send the right research and invitations to your organisation.",
      reg_org_name: "Organisation name",
      reg_org_type: "Type of organisation",
      reg_org_type_winery: "Winery / Wine Estate / Cooperative",
      reg_org_type_trade: "Trade, Logistics & Supply Chain",
      reg_org_type_university: "University / Research Institute",
      reg_org_type_association: "Appellation Council & Industry Association",
      reg_org_type_government: "Governmental / International Body / NGO",
      reg_org_type_other: "Other",
      reg_error_account_kind: "Please choose who this profile is for",
      reg_error_org_name: "Please enter your organisation's name",
      reg_error_org_type: "Please choose the type of organisation",
      reg_error_specify: "Please specify",
      reg_step_email: "Email",
      reg_step_info: "Info",
      reg_step_type: "Type",
      reg_step_region: "Region",
      reg_step_topics: "Topics",
      reg_email_intro: "Let's start with your email address. We'll check if it's available.",
      reg_checking_email: "Checking availability…",
      reg_email_available: "This email is available!",
      reg_email_taken: "This email is already registered.",
      reg_email_taken_login: "Already have an account? Log in instead →",
      reg_confirm_password: "Confirm password",
      reg_passwords_match: "Passwords match",
      reg_passwords_no_match: "Passwords don't match",
      reg_pwd_weak: "Weak",
      reg_pwd_fair: "Fair",
      reg_pwd_good: "Good",
      reg_pwd_strong: "Strong",
      reg_pwd_very_strong: "Very strong",
      reg_hide: "Hide",
      reg_show: "Show",
      reg_topics_optional: "Optional — pick topics you're interested in. You can change these later in your profile.",
      reg_describe_role: "Describe your role",
      reg_check_inbox_title: "Check your inbox!",
      reg_check_inbox_desc: "We've sent a verification email to:",
      reg_check_inbox_spam: "Didn't receive it? Check your spam folder or resend.",
      reg_resend_email: "Resend verification email",
      reg_go_to_login: "Go to login",
      reg_error_email: "Please enter a valid email",
      reg_error_first_name: "Please enter your first name",
      reg_error_last_name: "Please enter your last name",
      reg_error_password: "Password must be at least {{min}} characters",
      reg_error_password_mismatch: "Passwords don't match",
      reg_error_tos: "Please accept the Terms of Service",
      reg_error_user_type: "Please select a user type",
      reg_error_region: "Please select a regional affiliation",
      reg_error_generic: "Registration failed. Please try again.",
      reg_industry_details: "Industry details",
      reg_industry_required_hint:
        "Please choose at least one — it decides the research and invitations you receive.",
      reg_org_industry_details: "Your organisation's sector",
      reg_industry_optional_hint:
        "Optional — it helps us match your organisation to the right research and partners.",
      reg_account_kind_org_email_hint:
        "You may prefer to register with the organisation's address rather than your personal one.",
      reg_sector_prompt:
        "Which sectors describe your activity? (check all that apply)",
      reg_sector_prompt_org:
        "Which sectors does your organisation operate in? (check all that apply)",
      reg_work_in_winery: "I work in a winery",
      reg_winery_roles_prompt:
        "What roles apply to you? (check all that apply)",
      reg_other_role_prompt:
        'If you selected "Other (complete)", please specify',
      reg_region_label: "Regions",
      reg_north_america: "North America",
      reg_latin_america: "Latin America",
      reg_africa_me: "Africa and the Middle East",
      reg_asia_pacific: "Asia Pacific",
      reg_western_eu: "Western and Southern Europe",
      reg_eastern_eu: "Eastern Europe and Central Asia",
      reg_thematic_discussions: "Thematic Discussions",
      reg_loading_topics: "Loading your saved topics…",
      reg_change_later: "You can change these later in your profile.",
      reg_password_label: "Password",
      reg_min_characters: "Minimum {{min}} characters",
      reg_accept_terms: "I agree to the",
      reg_terms_link: "Terms of Service",
      reg_and_the: "and the",
      reg_privacy_link: "Privacy Policy",
      reg_back_button: "Back",
      reg_next_button: "Next",
      reg_create_account_button: "Create account",
      reg_loading_create: "Creating account",
      dashboard: {
        profile_completeness: "Profile completeness",
        next: "Next:",
        statistics: "Statistics",
        stats: "Statistics",
        profile_viewers: "Profile viewers",
        paper_viewers: "Paper viewers",
        post_impressions: "Post impressions",
        collections: "My Picks",
        posts: "Posts",
        publications: "Publications",
        notices: "Notices",
        notice_expires: "Until {{date}}",
        notice_open_board: "Open the Notice Board",
        filters_clear_all: "Clear all",
        filters_select_all: "Select all",
        connections: "Connections",
        connect: "Connect",
        bookmarks: "Bookmarks",
        groups: "Groups",
        events: "Events",
        discussion_boards: "Discussion Boards",
        loading_topics: "Loading topics…",
        no_topics: "No topics selected yet.",
        about_card_info:
          "This links to more information about the Global Wine Business Institute.",
        show: "Show:",
        show_more: "Show more",
        start_a_post: "Start a post",
        photo: "Photo",
        video: "Video",
        write_article: "Write article",
        create_post: "Create a post",
        post_to_anyone: "Post to Anyone",
        remove_media: "Remove media",
        post: "Post",
        loading_feed: "Loading feed...",
        no_matches: "No cards match the selected filters",
        news: "News",
        conferences: "Events",
        videos: "Videos",
        article: "Article",
        event: "Event",
        post_label: "Post",
        video_label: "Video",
        watch_video: "Watch video",
        more: "...more",
        date_unknown: "Date unknown",
        insight_prefix: "Insight:",
        member: "Member",
        your_name: "Your Name",
        notice_board_title: "Notice Board",
      },
      gwbi_team: {
        title: "The GWBI Team",
        intro: "The people who run the Global Wine Business Institute.",
        empty: "The team has not been set up yet.",
        member_fallback: "Member",
      },
      card_view: {
        heading: "Explore by Category",
        back_to_dashboard: "Back to Dashboard",
        description:
          "Pick a category to browse. Cards are square and open links in an in-app viewer.",
        tab_news: "News",
        tab_events: "Events",
        tab_publications: "Publications",
        tab_videos: "Videos",
        search_placeholder:
          "Search across news, events, publications, videos, notices, profiles...",
        search_button: "Search",
        clear_search: "Clear",
        loading: "Loading…",
        pill_event: "Event",
        pill_publication: "Publication",
        pill_news: "News",
        pill_video: "Video",
        insight_label: "Insight:",
        abstract_label: "Abstract:",
        keywords_label: "Keywords:",
        read_more: "Read more...",
        read_less: "Read less",
        more: "more",
        show_more: "Show more",
        no_matches_for_search: "No matches for this search.",
        authors_prefix: "by:",
        sign_up: "Sign up",
        modal_title: "Global Wine Business Institute",
        news_logo_alt: "News source",
        publication_logo_alt: "Journal logo",
        iframe_title: "Detail",
        tab_notice_board: "Notice Board",
        notice_dm_blocked_title: "Connect first",
        notice_dm_blocked_desc: "Send a connection request before messaging this member.",
        notice_type_label: "Notice type:",
        notice_type_all: "All notices",
        notice_type_coauthor: "Co-author requests",
        tab_profiles: "Profiles",
        pill_notice: "Notice",
        pill_profile: "Profile",
        notice_posted_by: "Posted by",
        notice_connect: "Connect",
        notice_category_collaboration: "Collaboration",
        notice_category_data: "Data",
        notice_category_student_project: "Student Project",
        notice_category_participation: "Call for Papers",
        notice_category_jobs: "Jobs",
        notice_category_opportunity: "Academic Opportunity",
      },
      login_slides: {
        global_reach: {
          title: "Global Reach",
          subtitle: "50,000 wineries & 1000+ wine researchers",
        },
        collaboration: {
          title: "Collaboration",
          subtitle: "Researchers & industry co-create",
        },
        insights: {
          title: "Insights",
          subtitle: "Knowledge, research & tools for growth",
        },
        ask_expert: {
          title: "Ask an Expert",
          subtitle: "Get answers from specialists worldwide",
        },
        reverse_seminars: {
          title: "Reverse Seminars",
          subtitle: "Industry presents, researchers respond",
        },
        weekly_digest: {
          title: "Weekly Digest",
          subtitle: "This Week in Wine Business",
        },
        winery_data: {
          title: "Winery Data",
          subtitle: "Find data on 5,300 wineries in seconds",
        },
        share_research: {
          title: "Share Research",
          subtitle: "Upload papers & reach practitioners",
        },
        scholarly_profiles: {
          title: "Scholarly Profiles",
          subtitle: "ORCID / SSRN / Google Scholar links",
        },
        themes: {
          title: "15 Themes",
          subtitle: "From Trade to Sustainability",
        },
        regional_clusters: {
          title: "Regional Clusters",
          subtitle: "Tailored views by market/region",
        },
        multilingual: {
          title: "Multilingual",
          subtitle: "EN / FR / ES / IT / DE / PT at launch",
        },
        smart_curation: {
          title: "Smart Curation",
          subtitle: "Scraping + NLP + human editorial",
        },
        actionable_insights: {
          title: "Actionable Insights",
          subtitle: "Translate research for decisions",
        },
        collaboration_board: {
          title: "Collaboration Board",
          subtitle: "Mentoring, projects, co-authorship",
        },
      },
      right_rail: {
        collaboration: "Collaboration",
        suggested_connections: "Suggested Connections",
        no_suggestions: "No suggestions yet.",
        upcoming_events: "Upcoming Events",
        no_upcoming_events: "No upcoming events.",
        tba: "TBA",
        untitled_event: "Untitled Event",
        register: "Register",
        current_topics: "Current Topics in the Forum",
        topic_wine_economics: "Market trends, trade flows, and pricing analysis.",
        topic_digital_viticulture: "Sensors, remote sensing, and vineyard data pipelines.",
        topic_fintech_wine: "Tokenization, payments, and blockchain traceability.",
        dataset_tools: "Visualising Wine",
        vinoverse_title: "Wine in Data",
        vinoverse_subtitle: "Maps, charts and stories on the data, policy and research shaping wine.",
        open: "Open",
        industry_reports: "Industry Reports",
        report_title_market_outlook: "Global Wine Market Outlook 2025",
        report_title_logistics: "Distribution & Logistics Benchmark",
        report_title_sustainability: "Sustainability in Wine 2024",
        report_desc_logistics: "Lead times, costs, and bottlenecks",
        report_desc_sustainability: "Certification adoption and ROI",
        report_desc_market: "Demand, pricing, and regional shifts",
        notice_board: {
          title: "Notice Board",
          subtitle:
            "Calls for data, collaborators, jobs and opportunities — from research and the wine industry.",
          cta: "Visit the board",
          add: "Add notice",
          data_calls: { title: "Calls for Data / Data Sharing" },
          collab_requests: { title: "Requests for Collaboration" },
          student_projects: { title: "Student Projects / Supervision" },
          calls_participation: { title: "Calls for Papers" },
          jobs: { title: "Jobs" },
          academic_opportunities: { title: "Academic Opportunities" },
        },
      },
      login_text: {
        email_verified_title: "Email verified!",
        email_verified_desc: "Your email has been successfully confirmed.",
        verification_failed_title: "Verification failed",
        verification_failed_desc_fallback: "The link is invalid or has expired.",
        network_error_title: "Network error",
        network_error_desc: "Could not verify your email. Please try again later.",
        resend_email_required_title: "Email required",
        resend_email_required_desc: "Enter your email before requesting a new link.",
        verification_email_sent_title: "Verification email sent",
        verification_email_sent_desc: "Please check your inbox.",
        verification_email_error_title: "Unable to resend verification",
        verification_email_error_desc: "Please try again later.",
        validation_email_required: "Please enter your email",
        validation_password_invalid: "Please enter a valid password (min 6 chars)",
        verify_required_message:
          "You need to verify your email first. Please check your inbox or resend the verification email.",
        login_failed_with_detail: "Login failed: {{detail}}",
        login_failed_default: "Email and/or password do not match our records.",
        login_generic_error: "Something went wrong during login.",
        forgot_email_required: "Please enter your email",
        forgot_success:
          "If the address exists in our records, we've sent a reset link. Please check your email.",
        forgot_error_with_detail: "Could not start reset: {{detail}}",
        forgot_error_default: "Could not start reset right now. Please try again later.",
        account_not_verified: "We found your account, but it isn't verified yet.",
        resend_verification_button: "Resend verification email",
        loading_news: "Loading news...",
        loading_events: "Loading events...",
        loading_publications: "Loading publications...",
      },
      top_menu: {
        home: "Home",
        gwbi_short: "GWBI",
        gwbi_about: "About the GWBI",
        gwbi_people: "GWBI People",
        governance: "Governance",
        founding_members: "Members",
        gwbi_workshops: "GWBI Workshops",
        contact: "Contact Us",
        funding_people: "GWBI people",
        funding_academic: "Academic Institutions",
        funding_partners: "Strategic Partners",
        funding_industry: "Wine Industry and Institutions",
        themes: "Themes",
        my_network: "My Network",
        my_world: "My World",
        grid: "Collections",
        notice_board: "Notice Board",
        profile: "Profile",
        settings: "Settings",
        logout: "Logout",
        search_placeholder: "Search",
        searching: "Searching…",
        no_results: "No results found.",
        search_failed_default: "Search failed",
        search_failed_with_status: "Search failed ({{status}})",
        search_source_people: "People",
        search_source_posts: "Posts",
        search_source_documents: "Uploaded Articles",
        search_source_publications: "Publications",
        search_source_videos: "Videos",
        search_source_wineries: "Wineries",
        search_source_other: "{{source}}",
        untitled: "Untitled",
        me: "Me",
        loading_themes: "Loading themes…",
        no_themes: "No themes available yet.",
        aria_gwbi_menu: "GWBI menu",
        aria_regions_menu: "Regions menu",
        aria_themes_menu: "Themes menu",
        aria_language_menu: "Change language",
        aria_mobile_menu: "Open navigation menu",
      },
      my_world: {
        heading: "My World",
        description: "Your network, events, and activity in one place.",
        search_placeholder: "Search...",
        tab_network: "My Network",
        tab_events: "Invitation to Events",
        tab_feed: "Activity Feed",
        no_items: "Nothing here yet.",
      },
      profile_extern: {
        heading: "Member Profile",
        back_to_dashboard: "Back to Dashboard",
        loading_profile: "Loading profile…",
        no_profile_selected: "No profile selected",
        member_fallback: "Member",
        theme_fallback: "Theme {{id}}",
        connect: "Connect",
        sign_in_to_connect: "Sign in to connect",
        block: "Block",
        block_confirm: "Block {{name}}? They will not be able to message you or send a connection request, and any existing connection is removed. They are not told.",
        block_done: "{{name}} has been blocked",
        block_error: "Could not block this member",
        view_profile: "Profile",
        connecting: "Connecting…",
        connected: "Connected",
        message: "Message",
        edit_profile: "Edit Profile",
        upload_paper: "+ Upload Paper",
        works_in_winery: "Works in a winery",
        themes_prefix: "Themes:",
        winery_roles_prefix: "Winery roles:",
        other_role_prefix: "Other role:",
        regions_prefix: "Regions:",
        organization: "Organization",
        country: "Country",
        city: "City",
        member_type: "Member Type",
        industry_categories: "Industry Categories",
        themes: "Themes",
        regions: "Regions",
        winery_roles: "Winery Roles",
        other_winery_role: "Other Winery Role",
        allows_data_sharing: "Allows data sharing",
        verified_member: "Verified member",
        contact_email: "Contact email",
        yes: "Yes",
        no: "No",
        followers: "Followers",
        connections: "Connections",
        search_appearances_7d: "Search appearances (7d)",
        profile_details: "Profile Details",
        about: "About",
        my_posts: "My posts",
        no_posts: "No posts yet.",
        no_notices: "No notices yet.",
        papers: "Papers",
        no_papers: "No papers found for this member.",
        paper_title_fallback: "Untitled",
        more: "more...",
        less: "less...",
        download_pdf: "Download PDF",
        download: "Download",
        open_link: "Open link",
        edit: "Edit",
        delete: "Delete",
        views_count: "{{count}} Views",
        connected_toast_title: "Connected",
        connected_toast_desc: "You now follow this member.",
        connect_error_title: "Could not connect",
        connect_error_desc: "Please try again later.",
        missing_doc_id: "Missing document id",
        confirm_delete: 'Delete "{{title}}"? This cannot be undone.',
        paper_deleted: "Paper deleted",
        paper_delete_error: "Could not delete paper",
        banner_alt: "Banner",
        link_icon_alt: "{{label}} icon",
        thumbnail_alt: "thumbnail",
        link_website: "Website",
        link_scholar: "Scholar",
        this_paper: "this paper",
        post_body_missing: "No text provided for this post.",
      },
      themes: {
      market_analysis: "Global and Domestic Market Analysis, Competitiveness, and Trade",
      marketing_branding: "Marketing, Branding, and Advertising",
      sensory_psychology: "Sensory, Consumer Psychology, and Linguistics",
      sustainability_climate: "Sustainability, Climate, and Environmental Transitions",
      innovation_tech_digital: "Innovation, Technology, and Digital Transformation",
      governance_strategy: "Governance, Strategy, and Business Models",
      finance_investment: "Finance, Investment, and Risk Management",
      human_capital: "Human Capital, Labor, and Firm Capabilities",
      wine_tourism: "Wine Tourism, Hospitality, and Culinary Arts",
      landscape_territory: "Landscape, Territorial Development & Regional Ecosystems",
      history_culture: "History, Culture, Heritage, and the Symbolic Value of Wine",
      regulation_policy: "Regulation, Policy, and Institutional Frameworks",
      supply_chain: "Supply Chain and Distribution",
      social_sustainability: "Social Sustainability, Ethics, and Worker Rights",
      education_training: "Wine Education, Professional Training, and Knowledge Transfer",
     },
     survey: {
       profile_title: "Survey Profile",
       benchmark_title: "Peer Benchmark",
       cohort_country: "Country",
       cohort_region: "Region",
       cohort_all: "All respondents",
       h01_region: "Region",
       h02_year_founded: "Founded",
       h03_company_type: "Company type",
       h04_annual_production_liters: "Annual production (L)",
       h05_harvest_method: "Harvest",
       h06_uses_commercial_yeasts: "Commercial yeasts",
       h07_has_premium_line: "Has premium line",
       h08_closures: "Closures used",
       h09_exports: "Exports",
       h10_export_volume_pct: "Export % of volume",
       h11_export_countries_count: "Export countries",
       h12_price_segments: "Price segments",
       h13_planner_vs_improviser: "Style",
       yes: "Yes",
       no: "No",
     },
      weekly_summary: {
        title: "This Week in Wine",
        week_label: "Week {{week}}, {{year}}",
        dismiss: "Dismiss until next week",
        journal_tab: "Business",
        academic_tab: "Academic",
        policy_tab: "Policy",
      },
    },
  },
  zh: {
    common: {
      countries: {
  france: "法国",
  spain: "西班牙",
  united_states: "美国",
  switzerland: "瑞士",
  germany: "德国",
  italy: "意大利",
  australia: "澳大利亚",
  croatia: "克罗地亚",
  chile: "智利",
},
      app_title: "全球葡萄酒商业与经济学网络",
      landing: {
        explore: "探索",
        join: "加入",
        explore_observatory: "探索观测站",
        sign_in: "登录",
        welcome_back: "欢迎回到研究院。",
        inside_network: "网络内部",
        everything: "研究院汇聚的一切。",
        live_community: "来自社区的实时动态",
        newswire: "葡萄酒新闻速递",
        latest_journals: "期刊最新动态",
        upcoming: "即将到来",
        vw_eyebrow: "Visualising Wine — 面向决策者、企业与学者",
        vw_heading: "探索数据，阅读气候故事，比较任意国家。",
        vw_sub: "为决策者、企业与学者打造的证据库——描述性、有据可查、可引用。",
        vw_card1_tag: "探索",
        vw_card1_title: "交互式地图集",
        vw_card1_desc: "所有酒庄尽在一张地图——按气候、品种、出口、风土等维度呈现。",
        vw_card2_tag: "故事",
        vw_card2_title: "三十年的升温",
        vw_card2_desc: "滚动查看 5,106 座葡萄园从 1980 年代至今的升温过程。",
        vw_card3_tag: "工具",
        vw_card3_title: "国家画像",
        vw_card3_desc: "选择一个国家，与同类国家逐项对比。",
        explore_data: "探索数据",
        data_heading: "全球首个企业层面的全景图，展现世界如何酿造葡萄酒。",
        data_sub: "21 个葡萄酒生产国，逐家酒庄调研——出口、有机占比、高端化与气候。在下方预览部分内容，或打开交互式地图集。",
        map_alt: "21 个葡萄酒调研国家",
        map_text: "21 个葡萄酒生产国尽在一张交互式地图——按出口、有机占比、高端化或气候着色，并深入了解任意国家。",
        open_atlas: "打开交互式地图集",
        country_portrait: "国家画像",
        gate_text: "正在预览 {{total}} 个国家中的 {{n}} 个——创建免费账户即可解锁全部国家画像、逐项对比以及完整研究工具。",
        gate_cta: "创建免费账户",
        no_account: "初来乍到？",
        verify_checking: "正在确认您的邮箱…",
        verify_ok_title: "邮箱已确认",
        verify_ok_desc: "您的邮箱已验证。现在即可登录您的账户。",
        verify_bad_title: "链接无效或已过期",
        verify_bad_desc: "此验证链接无效或已过期。请登录以重新申请。",
        verify_back: "返回登录",
        join_institute: "加入研究院",
        join_blurb: "与全球的研究者、企业和决策者建立联系——带来您的问题、使用研究工具，并加入全球葡萄酒社区的研讨会。调研由我们维护，成员只需作答。",
        create_free: "创建免费账户",
        see_all: "查看全部",
        more_platform: "平台更多内容",
        all_events: "所有活动",

watch_story: "什么是 GWBI？",
founding_members: "创始成员",
founding_members_heading:
  "Global Wine Business Institute 背后的创始机构。",
founding_members_desc:
  "GWBI 由全球葡萄酒领域的大学和研究机构共同合作创立。",
founding_institutions: "创始机构",
visit_institution: "访问机构网站",
},
      beta_banner:
        "测试版：本平台正在积极开发中，功能可能会有所变动。",
      login: "进入",
      register: "注册",
      email: "邮箱",
      password: "密码",
      remember_me: "记住我",
      forgot_password: "忘记密码？",
      create_account_cta: "创建免费账户",
      news: "新闻",
      conferences: "活动",
      research: "研究",
      insights: "洞察",
      get_started: "开始使用",
      see_details: "查看详情",
      reset_title: "重置您的密码",
      reset_desc: "请输入您的邮箱。若邮箱存在，我们将发送重置链接。",
      send_reset: "发送重置链接",
      cancel: "取消",
      reg_tagline:
        "当葡萄酒遇见知识——在全球葡萄酒商业中连接、分享、成长。",
      reg_create_account: "创建您的账户",
      reg_join: "加入全球葡萄酒社区",
      reg_first_name: "名字",
      reg_last_name: "姓氏",
      reg_user_type: "用户类型",
      reg_user_type_researcher: "学者 / 研究者",
      reg_user_type_student: "学生",
      reg_user_type_industry: "行业专业人士",
      industry_categories: {
        grape_grower: "葡萄种植者",
        wineries: "酒庄",
        distributors: "分销商",
        retailers: "零售商",
        supply_chain_partners: "供应链合作伙伴",
        hospitality: "餐旅业（餐厅、酒吧、酒店等）",
        media_journalism: "媒体与新闻",
        wine_educators: "葡萄酒教育者（侍酒师、品鉴师等）",
      },
      winery_roles: {
        owner: "庄主",
        winemaker: "酿酒师",
        assistant_winemaker: "助理酿酒师",
        enologist: "葡萄酒工艺师",
        vineyard_manager: "葡萄园经理",
        agronomist: "农艺师",
        cellar_master: "酒窖主管",
        operations_director: "运营总监",
        sales_manager: "销售经理",
        pr_manager: "公关经理",
        marketing_manager: "市场经理",
        other_complete: "其他（请填写）",
      },
      reg_user_type_policy: "决策者与公职人员",
      reg_user_type_enthusiast: "爱好者",
      reg_user_type_other: "其他",
      reg_other_specify: "请说明",
      reg_account_kind: "这份档案代表谁？",
      reg_account_kind_individual: "我本人",
      reg_account_kind_individual_hint:
        "档案将使用您本人的姓名，并列入“人员”目录。您所属的大学或雇主仍会显示在名片上——即使使用工作邮箱注册，也请选择此项。",
      reg_account_kind_organization: "我所代表的机构或企业",
      reg_account_kind_organization_hint:
        "档案将使用机构的名称和标志，并作为机构公开列出。仅当您在为该机构建立官方页面时才选择此项。",
      reg_org_heading: "您的机构",
      reg_org_optional_hint: "选填——有助于我们把合适的研究与邀请发送给您的机构。",
      reg_org_name: "机构名称",
      reg_org_type: "机构类型",
      reg_org_type_winery: "酒庄 / 葡萄酒庄园 / 合作社",
      reg_org_type_trade: "贸易、物流与供应链",
      reg_org_type_university: "大学 / 研究机构",
      reg_org_type_association: "法定产区委员会与行业协会",
      reg_org_type_government: "政府 / 国际组织 / 非政府组织",
      reg_org_type_other: "其他",
      reg_error_account_kind: "请选择这份档案代表谁",
      reg_error_org_name: "请填写机构名称",
      reg_error_org_type: "请选择机构类型",
      reg_error_specify: "请说明",
      reg_step_email: "邮箱",
      reg_step_info: "信息",
      reg_step_type: "类型",
      reg_step_region: "地区",
      reg_step_topics: "主题",
      reg_email_intro: "让我们先从您的邮箱开始。我们会检查它是否可用。",
      reg_checking_email: "正在检查可用性…",
      reg_email_available: "此邮箱可用！",
      reg_email_taken: "此邮箱已被注册。",
      reg_email_taken_login: "已有账户？直接登录 →",
      reg_confirm_password: "确认密码",
      reg_passwords_match: "密码一致",
      reg_passwords_no_match: "密码不一致",
      reg_pwd_weak: "弱",
      reg_pwd_fair: "一般",
      reg_pwd_good: "良好",
      reg_pwd_strong: "强",
      reg_pwd_very_strong: "非常强",
      reg_hide: "隐藏",
      reg_show: "显示",
      reg_topics_optional: "可选——选择您感兴趣的主题。您稍后可在个人资料中更改。",
      reg_describe_role: "描述您的角色",
      reg_check_inbox_title: "请查收您的邮箱！",
      reg_check_inbox_desc: "我们已向以下地址发送了验证邮件：",
      reg_check_inbox_spam: "没有收到？请检查垃圾邮件文件夹或重新发送。",
      reg_resend_email: "重新发送验证邮件",
      reg_go_to_login: "前往登录",
      reg_error_email: "请输入有效的邮箱",
      reg_error_first_name: "请输入您的名字",
      reg_error_last_name: "请输入您的姓氏",
      reg_error_password: "密码至少需要 {{min}} 个字符",
      reg_error_password_mismatch: "密码不一致",
      reg_error_tos: "请接受服务条款",
      reg_error_user_type: "请选择用户类型",
      reg_error_region: "请选择所属地区",
      reg_error_generic: "注册失败，请重试。",
      reg_industry_details: "行业详情",
      reg_sector_prompt:
        "哪些领域符合您的业务？（勾选所有适用项）",
      reg_work_in_winery: "我在酒庄工作",
      reg_winery_roles_prompt:
        "哪些角色适用于您？（勾选所有适用项）",
      reg_other_role_prompt:
        "如果您选择了“其他（请填写）”，请具体说明",
      reg_region_label: "地区",
      reg_north_america: "北美",
      reg_latin_america: "拉丁美洲",
      reg_africa_me: "非洲与中东",
      reg_asia_pacific: "亚太地区",
      reg_western_eu: "西欧与南欧",
      reg_eastern_eu: "东欧与中亚",
      reg_thematic_discussions: "主题讨论",
      reg_loading_topics: "正在加载您已保存的主题…",
      reg_change_later: "您稍后可在个人资料中更改这些设置。",
      reg_password_label: "密码",
      reg_min_characters: "至少 {{min}} 个字符",
      reg_accept_terms: "我同意",
      reg_terms_link: "服务条款",
      reg_and_the: "和",
      reg_privacy_link: "隐私政策",
      reg_back_button: "返回",
      reg_next_button: "下一步",
      reg_create_account_button: "创建账户",
      reg_loading_create: "正在创建账户",
      dashboard: {
        profile_completeness: "资料完整度",
        next: "下一步：",
        statistics: "统计数据",
        stats: "统计数据",
        profile_viewers: "资料访客",
        paper_viewers: "论文阅读者",
        post_impressions: "帖子曝光量",
        collections: "我的精选",
        posts: "帖子",
        publications: "出版物",
        notices: "公告",
        notice_expires: "截止 {{date}}",
        notice_open_board: "前往公告板",
        filters_clear_all: "全部清除",
        filters_select_all: "全部选择",
        connections: "人脉",
        connect: "连接",
        bookmarks: "书签",
        groups: "群组",
        events: "活动",
        discussion_boards: "讨论区",
        loading_topics: "正在加载主题…",
        no_topics: "尚未选择任何主题。",
        about_card_info:
          "此链接指向有关全球葡萄酒商业研究院的更多信息。",
        show: "显示：",
        show_more: "显示更多",
        start_a_post: "发布动态",
        photo: "照片",
        video: "视频",
        write_article: "撰写文章",
        create_post: "创建帖子",
        post_to_anyone: "向所有人发布",
        remove_media: "移除媒体",
        post: "发布",
        loading_feed: "正在加载动态…",
        no_matches: "没有符合所选筛选条件的卡片",
        news: "新闻",
        conferences: "活动",
        videos: "视频",
        article: "文章",
        event: "活动",
        post_label: "帖子",
        video_label: "视频",
        watch_video: "观看视频",
        more: "…更多",
        date_unknown: "日期未知",
        insight_prefix: "洞察：",
        member: "会员",
        your_name: "您的姓名",
        notice_board_title: "公告板",
      },
      gwbi_team: {
        title: "GWBI 团队",
        intro: "负责运营全球葡萄酒商业研究院的成员。",
        empty: "团队尚未设置。",
        member_fallback: "成员",
      },
      card_view: {
        heading: "按类别探索",
        back_to_dashboard: "返回仪表盘",
        description:
          "选择一个类别进行浏览。卡片为正方形，并在应用内查看器中打开链接。",
        tab_news: "新闻",
        tab_events: "活动",
        tab_publications: "出版物",
        tab_videos: "视频",
        search_placeholder:
          "搜索新闻、活动、出版物、视频、公告、个人资料…",
        search_button: "搜索",
        clear_search: "清除",
        loading: "加载中…",
        pill_event: "活动",
        pill_publication: "出版物",
        pill_news: "新闻",
        pill_video: "视频",
        insight_label: "洞察：",
        abstract_label: "摘要：",
        keywords_label: "关键词：",
        read_more: "阅读更多…",
        read_less: "收起",
        more: "更多",
        show_more: "显示更多",
        no_matches_for_search: "没有找到与此搜索匹配的结果。",
        authors_prefix: "作者：",
        sign_up: "注册",
        modal_title: "Global Wine Business Institute",
        news_logo_alt: "新闻来源",
        publication_logo_alt: "期刊标志",
        iframe_title: "详情",
        tab_notice_board: "公告板",
        notice_dm_blocked_title: "请先建立联系",
        notice_dm_blocked_desc: "请先发送联系请求，然后再给该成员发消息。",
        notice_type_label: "公告类型：",
        notice_type_all: "全部公告",
        notice_type_coauthor: "共同作者征集",
        tab_profiles: "个人资料",
        pill_notice: "公告",
        pill_profile: "资料",
        notice_posted_by: "发布者",
        notice_connect: "连接",
        notice_category_collaboration: "合作",
        notice_category_data: "数据",
        notice_category_student_project: "学生项目",
        notice_category_participation: "论文征集",
        notice_category_jobs: "招聘",
        notice_category_opportunity: "学术机会",
      },
      login_slides: {
        global_reach: {
          title: "全球覆盖",
          subtitle: "50,000 家酒庄及 1000+ 位葡萄酒研究者",
        },
        collaboration: {
          title: "协作",
          subtitle: "研究者与行业共同创造",
        },
        insights: {
          title: "洞察",
          subtitle: "助力成长的知识、研究与工具",
        },
        ask_expert: {
          title: "咨询专家",
          subtitle: "获取全球专家的解答",
        },
        reverse_seminars: {
          title: "反向研讨会",
          subtitle: "行业展示，研究者回应",
        },
        weekly_digest: {
          title: "每周摘要",
          subtitle: "本周葡萄酒商业动态",
        },
        winery_data: {
          title: "酒庄数据",
          subtitle: "几秒内找到 5,300 家酒庄的数据",
        },
        share_research: {
          title: "分享研究",
          subtitle: "上传论文，触达从业者",
        },
        scholarly_profiles: {
          title: "学术资料",
          subtitle: "ORCID / SSRN / Google Scholar 链接",
        },
        themes: {
          title: "15 个主题",
          subtitle: "从贸易到可持续发展",
        },
        regional_clusters: {
          title: "区域集群",
          subtitle: "按市场/地区定制的视图",
        },
        multilingual: {
          title: "多语言",
          subtitle: "发布时支持 EN / FR / ES / IT / DE / PT",
        },
        smart_curation: {
          title: "智能策展",
          subtitle: "抓取 + NLP + 人工编辑",
        },
        actionable_insights: {
          title: "可行动的洞察",
          subtitle: "将研究转化为决策",
        },
        collaboration_board: {
          title: "协作看板",
          subtitle: "指导、项目、合著",
        },
      },
      right_rail: {
        collaboration: "协作",
        suggested_connections: "推荐人脉",
        no_suggestions: "暂无推荐。",
        upcoming_events: "即将举行的活动",
        no_upcoming_events: "暂无即将举行的活动。",
        tba: "待定",
        untitled_event: "无标题活动",
        register: "注册",
        current_topics: "论坛当前话题",
        topic_wine_economics: "市场趋势、贸易流向与价格分析。",
        topic_digital_viticulture: "传感器、遥感与葡萄园数据管道。",
        topic_fintech_wine: "通证化、支付与区块链溯源。",
        dataset_tools: "葡萄酒数据可视化",
        vinoverse_title: "数据中的葡萄酒",
        vinoverse_subtitle: "关于塑造葡萄酒的数据、政策与研究的地图、图表与故事。",
        open: "打开",
        industry_reports: "行业报告",
        report_title_market_outlook: "2025 全球葡萄酒市场展望",
        report_title_logistics: "分销与物流基准",
        report_title_sustainability: "2024 葡萄酒可持续发展",
        report_desc_logistics: "交货周期、成本与瓶颈",
        report_desc_sustainability: "认证采用率与投资回报",
        report_desc_market: "需求、价格与区域变化",
        notice_board: {
          title: "公告板",
          subtitle:
            "来自学界与葡萄酒行业的数据征集、合作、招聘与各类机会。",
          cta: "前往公告板",
          add: "发布公告",
          data_calls: { title: "数据征集 / 数据共享" },
          collab_requests: { title: "合作请求" },
          student_projects: { title: "学生项目 / 指导" },
          calls_participation: { title: "论文征集" },
          jobs: { title: "招聘" },
          academic_opportunities: { title: "学术机会" },
        },
      },
      login_text: {
        email_verified_title: "邮箱已验证！",
        email_verified_desc: "您的邮箱已成功确认。",
        verification_failed_title: "验证失败",
        verification_failed_desc_fallback: "链接无效或已过期。",
        network_error_title: "网络错误",
        network_error_desc: "无法验证您的邮箱，请稍后重试。",
        resend_email_required_title: "需要邮箱",
        resend_email_required_desc: "请在申请新链接前输入您的邮箱。",
        verification_email_sent_title: "验证邮件已发送",
        verification_email_sent_desc: "请查收您的收件箱。",
        verification_email_error_title: "无法重新发送验证邮件",
        verification_email_error_desc: "请稍后重试。",
        validation_email_required: "请输入您的邮箱",
        validation_password_invalid: "请输入有效的密码（至少 6 个字符）",
        verify_required_message:
          "您需要先验证邮箱。请查收收件箱或重新发送验证邮件。",
        login_failed_with_detail: "登录失败：{{detail}}",
        login_failed_default: "邮箱和/或密码与我们的记录不匹配。",
        login_generic_error: "登录过程中出现问题。",
        forgot_email_required: "请输入您的邮箱",
        forgot_success:
          "如果该地址在我们的记录中存在，我们已发送重置链接。请查收您的邮箱。",
        forgot_error_with_detail: "无法启动重置：{{detail}}",
        forgot_error_default: "目前无法启动重置，请稍后重试。",
        account_not_verified: "我们找到了您的账户，但它尚未验证。",
        resend_verification_button: "重新发送验证邮件",
        loading_news: "正在加载新闻…",
        loading_events: "正在加载活动…",
        loading_publications: "正在加载出版物…",
      },
      top_menu: {
        home: "首页",
        gwbi_short: "GWBI",
        gwbi_about: "关于 GWBI",
        gwbi_people: "GWBI 成员",
        governance: "治理",
        founding_members: "会员",
        gwbi_workshops: "GWBI 工作坊",
        contact: "联系我们",
        funding_people: "GWBI 成员",
        funding_academic: "学术机构",
        funding_partners: "战略合作伙伴",
        funding_industry: "葡萄酒行业与机构",
        themes: "主题",
        my_network: "我的人脉",
        my_world: "我的世界",
        grid: "精选集",
        notice_board: "公告板",
        profile: "个人资料",
        settings: "设置",
        logout: "退出登录",
        search_placeholder: "搜索",
        searching: "搜索中…",
        no_results: "未找到结果。",
        search_failed_default: "搜索失败",
        search_failed_with_status: "搜索失败（{{status}}）",
        search_source_people: "人物",
        search_source_posts: "帖子",
        search_source_documents: "已上传文章",
        search_source_publications: "出版物",
        search_source_videos: "视频",
        search_source_wineries: "酒庄",
        search_source_other: "{{source}}",
        untitled: "无标题",
        me: "我",
        loading_themes: "正在加载主题…",
        no_themes: "暂无可用主题。",
        language: "语言",
        aria_gwbi_menu: "GWBI 菜单",
        aria_regions_menu: "地区菜单",
        aria_themes_menu: "主题菜单",
        aria_language_menu: "切换语言",
        aria_mobile_menu: "打开导航菜单",
      },
      my_world: {
        heading: "我的世界",
        description: "您的人脉、活动和动态尽在一处。",
        search_placeholder: "搜索…",
        tab_network: "我的人脉",
        tab_events: "活动邀请",
        tab_feed: "动态信息流",
        no_items: "这里还什么都没有。",
      },
      profile_extern: {
        heading: "会员资料",
        back_to_dashboard: "返回仪表盘",
        loading_profile: "正在加载资料…",
        no_profile_selected: "未选择资料",
        member_fallback: "会员",
        theme_fallback: "主题 {{id}}",
        connect: "连接",
        sign_in_to_connect: "登录后建立联系",
        block: "屏蔽",
        block_confirm: "确定屏蔽 {{name}}？对方将无法给你发送消息或联系请求，现有联系也会解除。对方不会收到通知。",
        block_done: "已屏蔽 {{name}}",
        block_error: "无法屏蔽该成员",
        view_profile: "个人资料",
        connecting: "连接中…",
        connected: "已连接",
        message: "私信",
        edit_profile: "编辑资料",
        upload_paper: "+ 上传论文",
        works_in_winery: "在酒庄工作",
        themes_prefix: "主题：",
        winery_roles_prefix: "酒庄角色：",
        other_role_prefix: "其他角色：",
        regions_prefix: "地区：",
        organization: "机构",
        country: "国家/地区",
        city: "城市",
        member_type: "会员类型",
        industry_categories: "行业类别",
        themes: "主题",
        regions: "地区",
        winery_roles: "酒庄角色",
        other_winery_role: "其他酒庄角色",
        allows_data_sharing: "允许数据共享",
        verified_member: "已验证会员",
        contact_email: "联系邮箱",
        yes: "是",
        no: "否",
        followers: "关注者",
        connections: "人脉",
        search_appearances_7d: "搜索曝光（7 天）",
        profile_details: "资料详情",
        about: "简介",
        my_posts: "我的帖子",
        no_posts: "暂无帖子。",
        no_notices: "暂无公告。",
        papers: "论文",
        no_papers: "未找到该会员的论文。",
        paper_title_fallback: "无标题",
        more: "更多…",
        less: "收起…",
        download_pdf: "下载 PDF",
        download: "下载",
        open_link: "打开链接",
        edit: "编辑",
        delete: "删除",
        views_count: "{{count}} 次浏览",
        connected_toast_title: "已连接",
        connected_toast_desc: "您现在关注了该会员。",
        connect_error_title: "无法连接",
        connect_error_desc: "请稍后重试。",
        missing_doc_id: "缺少文档 ID",
        confirm_delete: "删除“{{title}}”？此操作无法撤销。",
        paper_deleted: "论文已删除",
        paper_delete_error: "无法删除论文",
        banner_alt: "横幅",
        link_icon_alt: "{{label}} 图标",
        thumbnail_alt: "缩略图",
        link_website: "网站",
        link_scholar: "Scholar",
        this_paper: "本论文",
        post_body_missing: "此帖子未提供文本内容。",
      },
      themes: {
        market_analysis: "全球与国内市场分析、竞争力与贸易",
        marketing_branding: "市场营销、品牌与广告",
        sensory_psychology: "感官、消费者心理与语言学",
        sustainability_climate: "可持续发展、气候与环境转型",
        innovation_tech_digital: "创新、技术与数字化转型",
        governance_strategy: "治理、战略与商业模式",
        finance_investment: "金融、投资与风险管理",
        human_capital: "人力资本、劳动力与企业能力",
        wine_tourism: "葡萄酒旅游、酒店款待与烹饪艺术",
        landscape_territory: "景观、区域发展与地区生态系统",
        history_culture: "历史、文化、遗产与葡萄酒的象征价值",
        regulation_policy: "监管、政策与制度框架",
        supply_chain: "供应链与分销",
        social_sustainability: "社会可持续发展、伦理与工人权益",
        education_training: "葡萄酒教育、专业培训与知识传递",
      },
      survey: {
        profile_title: "调研概况",
        benchmark_title: "同行基准",
        cohort_country: "国家/地区",
        cohort_region: "地区",
        cohort_all: "所有受访者",
        h01_region: "地区",
        h02_year_founded: "成立年份",
        h03_company_type: "公司类型",
        h04_annual_production_liters: "年产量（升）",
        h05_harvest_method: "采收方式",
        h06_uses_commercial_yeasts: "使用商业酵母",
        h07_has_premium_line: "拥有高端产品线",
        h08_closures: "使用的封瓶方式",
        h09_exports: "出口",
        h10_export_volume_pct: "出口占产量百分比",
        h11_export_countries_count: "出口国家数",
        h12_price_segments: "价格区间",
        h13_planner_vs_improviser: "风格",
        yes: "是",
        no: "否",
      },
      weekly_summary: {
        title: "本周葡萄酒动态",
        week_label: "第 {{week}} 周，{{year}} 年",
        dismiss: "在下周之前不再显示",
        journal_tab: "商业",
        academic_tab: "学术",
        policy_tab: "政策",
      },
    },
  },
  fr: {
    common: {
      countries: {
  france: "France",
  spain: "Espagne",
  united_states: "États-Unis",
  switzerland: "Suisse",
  germany: "Allemagne",
  italy: "Italie",
  australia: "Australie",
  croatia: "Croatie",
  chile: "Chili",
},

      app_title: "Un réseau mondial pour le business et la recherche du vin",
      landing: {
        explore: "Explorer",
        join: "Rejoindre",
        explore_observatory: "Explorer l'Observatoire",
        sign_in: "Se connecter",
        welcome_back: "Bon retour à l'institut.",
        inside_network: "Au cœur du réseau",
        everything: "Tout ce que l'institut rassemble.",
        live_community: "En direct de la communauté",
        newswire: "Fil d'actualité du vin",
        latest_journals: "Dernières publications des revues",
        upcoming: "À venir",
        vw_eyebrow: "Visualising Wine — pour décideurs, entreprises & universitaires",
        vw_heading: "Explorez les données, lisez les récits climatiques, comparez les pays.",
        vw_sub: "Une base de données pour décideurs, entreprises et universitaires — descriptive, sourcée et citable.",
        vw_card1_tag: "Explorer",
        vw_card1_title: "L'Atlas interactif",
        vw_card1_desc: "Chaque domaine sur une carte — par climat, cépage, exportations, terroir et plus encore.",
        vw_card2_tag: "Récit",
        vw_card2_title: "Trois décennies de réchauffement",
        vw_card2_desc: "Faites défiler et observez 5 106 vignobles se réchauffer entre les années 1980 et aujourd'hui.",
        vw_card3_tag: "Outil",
        vw_card3_title: "Portrait de pays",
        vw_card3_desc: "Choisissez un pays et comparez-le à ses pairs, tête-à-tête.",
        explore_data: "Explorer les données",
        data_heading: "Le premier panorama mondial, à l'échelle des entreprises, de la façon dont le monde fait du vin.",
        data_sub: "21 pays producteurs de vin, étudiés domaine par domaine — exportations, part du bio, montée en gamme et climat. Aperçu de quelques-uns ci-dessous, ou ouvrez l'atlas interactif.",
        map_alt: "Les 21 pays de l'enquête vitivinicole",
        map_text: "Les 21 pays producteurs de vin sur une seule carte interactive — colorez par exportations, part du bio, montée en gamme ou climat et explorez chaque pays.",
        open_atlas: "Ouvrir l'atlas interactif",
        country_portrait: "Portrait de pays",
        gate_text: "Aperçu de {{n}} pays sur {{total}} — créez un compte gratuit pour débloquer tous les portraits de pays, les comparaisons directes et l'ensemble des outils de recherche.",
        gate_cta: "Créer un compte gratuit",
        no_account: "Nouveau ici ?",
        verify_checking: "Confirmation de votre e-mail…",
        verify_ok_title: "E-mail confirmé",
        verify_ok_desc: "Votre e-mail est vérifié. Vous pouvez maintenant vous connecter à votre compte.",
        verify_bad_title: "Lien invalide ou expiré",
        verify_bad_desc: "Ce lien de vérification est invalide ou a expiré. Connectez-vous pour en demander un nouveau.",
        verify_back: "Retour à la connexion",
        join_institute: "Rejoindre l'institut",
        join_blurb: "Connectez-vous avec chercheurs, entreprises et décideurs du monde entier — apportez une question, utilisez les outils de recherche et participez aux séminaires de la communauté vitivinicole mondiale. L'enquête, c'est nous qui la tenons à jour ; les membres n'ont qu'à y répondre.",
        create_free: "Créer un compte gratuit",
        see_all: "Voir tout",
        more_platform: "Plus sur la plateforme",
        all_events: "Tous les événements",

watch_story: "Qu'est-ce que le GWBI ?",
founding_members: "Membres fondateurs",
founding_members_heading:
  "Les institutions à l'origine du Global Wine Business Institute.",
founding_members_desc:
  "Le GWBI est né de la collaboration entre des universités et des institutions de recherche de la communauté mondiale du vin.",
founding_institutions: "Institutions fondatrices",
visit_institution: "Visiter l'institution",
},
      beta_banner:
        "Beta : plateforme en développement actif. Les fonctionnalités peuvent changer.",
      login: "Se connecter",
      register: "S’inscrire",
      email: "E-mail",
      password: "Mot de passe",
      remember_me: "Se souvenir de moi",
      forgot_password: "Mot de passe oublié ?",
      create_account_cta: "Créer un compte gratuit",
      news: "Actualités",
      conferences: "Événements",
      research: "Recherche",
      insights: "Analyses",
      get_started: "Commencer",
      see_details: "Voir les détails",
      reset_title: "Réinitialisez votre mot de passe",
      reset_desc: "Entrez votre e-mail. S’il existe, nous enverrons un lien.",
      send_reset: "Envoyer le lien",
      cancel: "Annuler",
      reg_tagline:
        "Où le vin rencontre le savoir — Connectez, partagez et développez-vous dans le monde des affaires du vin.",
      reg_create_account: "Créez votre compte",
      reg_join: "Rejoignez la communauté mondiale du vin",
      reg_first_name: "Prénom",
      reg_last_name: "Nom",
      reg_user_type: "Type d'utilisateur",
      reg_user_type_researcher: "Universitaire / Chercheur",
      reg_user_type_student: "Étudiant",
      reg_user_type_industry: "Professionnel de l'industrie",
       industry_categories: {
        grape_grower: "Producteur de raisin",
        wineries: "Domaines / caves",
        distributors: "Distributeurs",
        retailers: "Détaillants",
        supply_chain_partners: "Partenaires de la chaîne d'approvisionnement",
        hospitality:
          "Restauration & hôtellerie (restaurants, bars, hôtels…)",
        media_journalism: "Médias et journalisme",
        wine_educators:
          "Formateurs en vin (sommeliers, dégustateurs…)",
      },
      winery_roles: {
        owner: "Propriétaire",
        winemaker: "Winemaker",
        assistant_winemaker: "Winemaker adjoint·e",
        enologist: "Œnologue",
        vineyard_manager: "Responsable de vignoble",
        agronomist: "Agronome",
        cellar_master: "Maître de chai",
        operations_director:
          "Directeur / directrice des opérations",
        sales_manager: "Responsable des ventes",
        pr_manager: "Responsable relations publiques",
        marketing_manager: "Responsable marketing",
        other_complete: "Autre (à préciser)",
      },
      reg_user_type_policy: "Décideur public et agent de l'État",
      reg_user_type_enthusiast: "Passionné",
      reg_user_type_other: "Autre",
      reg_other_specify: "Veuillez préciser",
      reg_account_kind: "À qui ce profil appartient-il ?",
      reg_account_kind_individual: "À moi — une personne",
      reg_account_kind_individual_hint:
        "Le profil porte votre nom et figure dans l'annuaire des personnes. Votre université ou votre employeur reste affiché sur votre fiche — choisissez cette option même si vous vous inscrivez avec une adresse professionnelle.",
      reg_account_kind_organization: "À une institution ou entreprise que je représente",
      reg_account_kind_organization_hint:
        "Le profil porte le nom et le logo de l'organisation et est répertorié publiquement comme institution. Ne choisissez cette option que si vous créez la page officielle de l'organisation.",
      reg_org_heading: "Votre organisation",
      reg_org_optional_hint: "Facultatif — cela nous aide à adresser les bonnes recherches et invitations à votre organisation.",
      reg_org_name: "Nom de l'organisation",
      reg_org_type: "Type d'organisation",
      reg_org_type_winery: "Domaine viticole / Cave / Coopérative",
      reg_org_type_trade: "Négoce, logistique et chaîne d'approvisionnement",
      reg_org_type_university: "Université / Institut de recherche",
      reg_org_type_association: "Conseil d'appellation et association professionnelle",
      reg_org_type_government: "Organisme public / International / ONG",
      reg_org_type_other: "Autre",
      reg_error_account_kind: "Veuillez indiquer à qui appartient ce profil",
      reg_error_org_name: "Veuillez indiquer le nom de votre organisation",
      reg_error_org_type: "Veuillez choisir le type d'organisation",
      reg_error_specify: "Veuillez préciser",
      reg_step_email: "Email",
      reg_step_info: "Infos",
      reg_step_type: "Type",
      reg_step_region: "Région",
      reg_step_topics: "Sujets",
      reg_email_intro: "Commençons par votre adresse email. Nous vérifierons sa disponibilité.",
      reg_checking_email: "Vérification en cours…",
      reg_email_available: "Cette adresse email est disponible !",
      reg_email_taken: "Cette adresse email est déjà enregistrée.",
      reg_email_taken_login: "Vous avez déjà un compte ? Connectez-vous →",
      reg_confirm_password: "Confirmer le mot de passe",
      reg_passwords_match: "Les mots de passe correspondent",
      reg_passwords_no_match: "Les mots de passe ne correspondent pas",
      reg_pwd_weak: "Faible",
      reg_pwd_fair: "Moyen",
      reg_pwd_good: "Bon",
      reg_pwd_strong: "Fort",
      reg_pwd_very_strong: "Très fort",
      reg_hide: "Cacher",
      reg_show: "Afficher",
      reg_topics_optional: "Optionnel — choisissez les sujets qui vous intéressent. Vous pouvez les changer plus tard.",
      reg_describe_role: "Décrivez votre rôle",
      reg_check_inbox_title: "Vérifiez votre boîte mail !",
      reg_check_inbox_desc: "Nous avons envoyé un email de vérification à :",
      reg_check_inbox_spam: "Vous ne l'avez pas reçu ? Vérifiez vos spams ou renvoyez-le.",
      reg_resend_email: "Renvoyer l'email de vérification",
      reg_go_to_login: "Aller à la connexion",
      reg_error_email: "Veuillez saisir un email valide",
      reg_error_first_name: "Veuillez saisir votre prénom",
      reg_error_last_name: "Veuillez saisir votre nom",
      reg_error_password: "Le mot de passe doit contenir au moins {{min}} caractères",
      reg_error_password_mismatch: "Les mots de passe ne correspondent pas",
      reg_error_tos: "Veuillez accepter les conditions d'utilisation",
      reg_error_user_type: "Veuillez sélectionner un type d'utilisateur",
      reg_error_region: "Veuillez sélectionner une affiliation régionale",
      reg_error_generic: "L'inscription a échoué. Veuillez réessayer.",
      reg_industry_details: "Détails de l'industrie",
      reg_sector_prompt:
        "Quels secteurs décrivent votre activité ? (cochez tout ce qui s'applique)",
      reg_work_in_winery: "Je travaille dans un domaine viticole",
      reg_winery_roles_prompt:
        "Quels rôles s'appliquent à vous ? (cochez tout ce qui s'applique)",
      reg_other_role_prompt:
        'Si vous avez sélectionné "Autre (compléter)", veuillez préciser',
      reg_region_label: "Regions",
      reg_north_america: "Amérique du Nord",
      reg_latin_america: "Amérique latine",
      reg_africa_me: "Afrique et Moyen-Orient",
      reg_asia_pacific: "Asie-Pacifique",
      reg_western_eu: "Europe occidentale et méridionale",
      reg_eastern_eu: "Europe de l'Est et Asie centrale",
      reg_thematic_discussions: "Discussions thématiques",
      reg_loading_topics: "Chargement de vos sujets enregistrés…",
      reg_change_later: "Vous pouvez changer cela plus tard dans votre profil.",
      reg_password_label: "Mot de passe",
      reg_min_characters: "Minimum {{min}} caractères",
      reg_accept_terms: "J'accepte les",
      reg_terms_link: "Conditions d'utilisation",
      reg_and_the: "et la",
      reg_privacy_link: "Politique de confidentialité",
      reg_back_button: "Retour",
      reg_next_button: "Suivant",
      reg_create_account_button: "Créer un compte",
      reg_loading_create: "Création du compte",
      dashboard: {
        profile_completeness: "Complétude du profil",
        next: "Suivant :",
        statistics: "Statistiques",
        stats: "Statistiques",
        profile_viewers: "Visiteurs du profil",
        paper_viewers: "Lecteurs des articles",
        post_impressions: "Impressions des publications",
        collections: "Mes sélections",
        posts: "Posts",
        publications: "Publications",
        notices: "Annonces",
        notice_expires: "Jusqu'au {{date}}",
        notice_open_board: "Ouvrir le tableau des annonces",
        filters_clear_all: "Tout effacer",
        filters_select_all: "Tout sélectionner",
        connections: "Connexions",
        connect: "Se connecter",
        bookmarks: "Favoris",
        groups: "Groupes",
        events: "Événements",
        discussion_boards: "Forums de discussion",
        loading_topics: "Chargement des sujets…",
        no_topics: "Aucun sujet sélectionné pour l’instant.",
        about_card_info:
          "Ce lien mène à plus d’informations sur le Global Wine Business Institute.",
        show: "Afficher :",
        show_more: "Afficher plus",
        start_a_post: "Commencer une publication",
        photo: "Photo",
        video: "Vidéo",
        write_article: "Écrire un article",
        create_post: "Créer une publication",
        post_to_anyone: "Publier pour tout le monde",
        remove_media: "Retirer le média",
        post: "Publier",
        loading_feed: "Chargement du fil...",
        no_matches: "Aucune carte ne correspond aux filtres sélectionnés",
        news: "Actualités",
        conferences: "Événements",
        videos: "Vidéos",
        article: "Article",
        event: "Événement",
        post_label: "Post",
        video_label: "Vidéo",
        watch_video: "Regarder la vidéo",
        more: "...plus",
        date_unknown: "Date inconnue",
        insight_prefix: "Analyse :",
        member: "Membre",
        your_name: "Votre nom",
        notice_board_title: "Tableau des annonces",
      },
      gwbi_team: {
        title: "L'équipe GWBI",
        intro: "Les personnes qui dirigent le Global Wine Business Institute.",
        empty: "L'équipe n'a pas encore été configurée.",
        member_fallback: "Membre",
      },
      card_view: {
        heading: "Explorer par catégorie",
        back_to_dashboard: "Retour au tableau de bord",
        description:
          "Choisissez une catégorie à parcourir. Les cartes sont carrées et ouvrent les liens dans une visionneuse intégrée.",
        tab_news: "Actualités",
        tab_events: "Événements",
        tab_publications: "Publications",
        tab_videos: "Vidéos",
        search_placeholder:
          "Rechercher dans actualités, événements, publications, vidéos, annonces, profils...",
        search_button: "Rechercher",
        clear_search: "Effacer",
        loading: "Chargement…",
        pill_event: "Événement",
        pill_publication: "Publication",
        pill_news: "Actualités",
        pill_video: "Vidéo",
        insight_label: "Analyse :",
        abstract_label: "Résumé :",
        keywords_label: "Mots-clés :",
        read_more: "Lire la suite...",
        read_less: "Lire moins",
        more: "plus",
        show_more: "Afficher plus",
        no_matches_for_search: "Aucun résultat pour cette recherche.",
        authors_prefix: "par :",
        sign_up: "S'inscrire",
        modal_title: "Global Wine Business Institute",
        news_logo_alt: "Source d'actualités",
        publication_logo_alt: "Logo de la revue",
        iframe_title: "Détail",
        tab_notice_board: "Tableau des annonces",
        notice_dm_blocked_title: "Connectez-vous d'abord",
        notice_dm_blocked_desc: "Envoyez une demande de connexion avant d'écrire à ce membre.",
        notice_type_label: "Type d'annonce :",
        notice_type_all: "Toutes les annonces",
        notice_type_coauthor: "Recherches de co-auteurs",
        tab_profiles: "Profils",
        pill_notice: "Annonce",
        pill_profile: "Profil",
        notice_posted_by: "Publié par",
        notice_connect: "Se connecter",
        notice_category_collaboration: "Collaboration",
        notice_category_data: "Données",
        notice_category_student_project: "Projet étudiant",
        notice_category_participation: "Appel à communications",
        notice_category_jobs: "Emplois",
        notice_category_opportunity: "Opportunité académique",
      },
      login_slides: {
        global_reach: {
          title: "Portée mondiale",
          subtitle: "50 000 domaines & plus de 1 000 chercheurs en vin",
        },
        collaboration: {
          title: "Collaboration",
          subtitle: "Chercheurs et industrie co‑créent",
        },
        insights: {
          title: "Analyses",
          subtitle: "Savoirs, recherche et outils pour croître",
        },
        ask_expert: {
          title: "Demander à un expert",
          subtitle: "Obtenez des réponses de spécialistes du monde entier",
        },
        reverse_seminars: {
          title: "Séminaires inversés",
          subtitle: "L'industrie présente, les chercheurs répondent",
        },
        weekly_digest: {
          title: "Revue hebdomadaire",
          subtitle: "Cette semaine dans le business du vin",
        },
        winery_data: {
          title: "Données des domaines",
          subtitle: "Trouvez en quelques secondes des données sur 5 300 domaines",
        },
        share_research: {
          title: "Partager la recherche",
          subtitle: "Téléversez vos articles et touchez les praticiens",
        },
        scholarly_profiles: {
          title: "Profils académiques",
          subtitle: "Liens ORCID / SSRN / Google Scholar",
        },
        themes: {
          title: "15 thématiques",
          subtitle: "Du commerce à la durabilité",
        },
        regional_clusters: {
          title: "Clusters régionaux",
          subtitle: "Vues adaptées par marché/région",
        },
        multilingual: {
          title: "Multilingue",
          subtitle: "EN / FR / ES / IT / DE / PT au lancement",
        },
        smart_curation: {
          title: "Curation intelligente",
          subtitle: "Scraping + NLP + édition humaine",
        },
        actionable_insights: {
          title: "Analyses actionnables",
          subtitle: "Traduire la recherche en décisions",
        },
        collaboration_board: {
          title: "Espace collaboration",
          subtitle: "Mentorat, projets, co‑signature",
        },
      },
      right_rail: {
        collaboration: "Collaboration",
        suggested_connections: "Connexions suggérées",
        no_suggestions: "Aucune suggestion pour le moment.",
        upcoming_events: "Événements à venir",
        no_upcoming_events: "Aucun événement à venir.",
        tba: "À confirmer",
        untitled_event: "Événement sans titre",
        register: "S'inscrire",
        current_topics: "Sujets actuels sur le forum",
        topic_wine_economics:
          "Tendances du marché, flux commerciaux et analyse des prix.",
        topic_digital_viticulture:
          "Capteurs, télédétection et pipelines de données viticoles.",
        topic_fintech_wine:
          "Tokenisation, paiements et traçabilité blockchain.",
        dataset_tools: "Visualiser le vin",
        vinoverse_title: "Le vin en données",
        vinoverse_subtitle: "Cartes, graphiques et récits sur les données, les politiques et la recherche.",
        open: "Ouvrir",
        industry_reports: "Rapports sectoriels",
        report_title_market_outlook: "Perspectives du marché mondial du vin 2025",
        report_title_logistics: "Benchmark distribution & logistique",
        report_title_sustainability: "Durabilité dans le vin 2024",
        report_desc_logistics: "Délais, coûts et goulots d'étranglement",
        report_desc_sustainability: "Adoption des certifications et ROI",
        report_desc_market: "Demande, prix et évolutions régionales",
        notice_board: {
          title: "Tableau des annonces",
          subtitle:
            "Appels à données, collaborations, emplois et opportunités — recherche et filière vin.",
          cta: "Aller au tableau",
          add: "Publier une annonce",
          data_calls: { title: "Appels à données / partage" },
          collab_requests: { title: "Demandes de collaboration" },
          student_projects: {
            title: "Projets étudiants / encadrement",
          },
          calls_participation: { title: "Appels à communications" },
          jobs: { title: "Emplois" },
          academic_opportunities: { title: "Opportunités académiques" },
        },
      },
      login_text: {
        email_verified_title: "E-mail vérifié !",
        email_verified_desc: "Votre e-mail a été confirmé avec succès.",
        verification_failed_title: "Échec de la vérification",
        verification_failed_desc_fallback: "Le lien est invalide ou a expiré.",
        network_error_title: "Erreur réseau",
        network_error_desc:
          "Impossible de vérifier votre e-mail. Veuillez réessayer plus tard.",
        resend_email_required_title: "E-mail requis",
        resend_email_required_desc:
          "Indiquez votre e-mail avant de demander un nouveau lien.",
        verification_email_sent_title: "E-mail de vérification envoyé",
        verification_email_sent_desc: "Veuillez vérifier votre boîte de réception.",
        verification_email_error_title: "Impossible de renvoyer la vérification",
        verification_email_error_desc: "Veuillez réessayer plus tard.",
        validation_email_required: "Veuillez saisir votre e-mail",
        validation_password_invalid:
          "Veuillez saisir un mot de passe valide (min. 6 caractères)",
        verify_required_message:
          "Vous devez d'abord vérifier votre e-mail. Consultez votre boîte mail ou renvoyez l'e-mail de vérification.",
        login_failed_with_detail: "Connexion échouée : {{detail}}",
        login_failed_default:
          "L'e-mail et/ou le mot de passe ne correspondent pas à nos enregistrements.",
        login_generic_error: "Une erreur s'est produite lors de la connexion.",
        forgot_email_required: "Veuillez saisir votre e-mail",
        forgot_success:
          "Si l'adresse existe dans nos dossiers, nous avons envoyé un lien de réinitialisation. Veuillez vérifier votre e-mail.",
        forgot_error_with_detail: "Impossible de lancer la réinitialisation : {{detail}}",
        forgot_error_default:
          "Impossible de lancer la réinitialisation pour le moment. Veuillez réessayer plus tard.",
        account_not_verified:
          "Nous avons trouvé votre compte, mais il n'est pas encore vérifié.",
        resend_verification_button: "Renvoyer l'e-mail de vérification",
        loading_news: "Chargement des actualités...",
        loading_events: "Chargement des événements...",
        loading_publications: "Chargement des publications...",
      },
      top_menu: {
        home: "Accueil",
        gwbi_short: "GWBI",
        gwbi_about: "À propos du GWBI",
        governance: "Gouvernance",
        founding_members: "Membres fondateurs",
        gwbi_workshops: "Ateliers GWBI",
        contact: "Contactez-nous",
        funding_people: "Personnes du GWBI",
        funding_academic: "Institutions académiques",
        funding_partners: "Partenaires stratégiques",
        funding_industry: "Industrie du vin et institutions",
        themes: "Thèmes",
        my_network: "Mon réseau",
        my_world: "Mon Monde",
        grid: "Collections",
        notice_board: "Tableau des annonces",
        profile: "Profil",
        settings: "Paramètres",
        logout: "Se déconnecter",
        search_placeholder: "Rechercher",
        searching: "Recherche…",
        no_results: "Aucun résultat.",
        search_failed_default: "Recherche échouée",
        search_failed_with_status: "Recherche échouée ({{status}})",
        search_source_people: "Personnes",
        search_source_posts: "Publications",
        search_source_documents: "Articles téléversés",
        search_source_publications: "Publications",
        search_source_videos: "Vidéos",
        search_source_wineries: "Domaines",
        search_source_other: "{{source}}",
        untitled: "Sans titre",
        me: "Moi",
        loading_themes: "Chargement des thèmes…",
        no_themes: "Aucun thème disponible pour le moment.",
        aria_gwbi_menu: "Menu GWBI",
        aria_regions_menu: "Menu des régions",
        aria_themes_menu: "Menu des thèmes",
        aria_language_menu: "Changer de langue",
        aria_mobile_menu: "Ouvrir le menu de navigation",
      },
      my_world: {
        heading: "Mon Monde",
        description: "Votre réseau, événements et activité en un seul endroit.",
        search_placeholder: "Rechercher...",
        tab_network: "Mon Réseau",
        tab_events: "Invitation aux événements",
        tab_feed: "Fil d'activité",
        no_items: "Rien ici pour le moment.",
      },
      profile_extern: {
        heading: "Profil du membre",
        back_to_dashboard: "Retour au tableau de bord",
        loading_profile: "Chargement du profil…",
        no_profile_selected: "Aucun profil sélectionné",
        member_fallback: "Membre",
        theme_fallback: "Thème {{id}}",
        connect: "Se connecter",
        sign_in_to_connect: "Connectez-vous pour échanger",
        block: "Bloquer",
        block_confirm: "Bloquer {{name}} ? Cette personne ne pourra plus vous écrire ni vous envoyer de demande, et toute connexion existante sera supprimée. Elle n'en sera pas informée.",
        block_done: "{{name}} a été bloqué",
        block_error: "Impossible de bloquer ce membre",
        view_profile: "Profil",
        connecting: "Connexion…",
        connected: "Connecté",
        message: "Message",
        edit_profile: "Modifier le profil",
        upload_paper: "+ Téléverser un article",
        works_in_winery: "Travaille dans une cave",
        themes_prefix: "Thèmes :",
        winery_roles_prefix: "Rôles dans la cave :",
        other_role_prefix: "Autre rôle :",
        regions_prefix: "Régions :",
        organization: "Organisation",
        country: "Pays",
        city: "Ville",
        member_type: "Type de membre",
        industry_categories: "Catégories d'industrie",
        themes: "Thèmes",
        regions: "Régions",
        winery_roles: "Rôles dans la cave",
        other_winery_role: "Autre rôle dans la cave",
        allows_data_sharing: "Autorise le partage des données",
        verified_member: "Membre vérifié",
        contact_email: "E-mail de contact",
        yes: "Oui",
        no: "Non",
        followers: "Abonnés",
        connections: "Connexions",
        search_appearances_7d: "Apparitions dans la recherche (7 j)",
        profile_details: "Détails du profil",
        about: "À propos",
        my_posts: "Mes publications",
        no_posts: "Aucune publication pour le moment.",
        no_notices: "Aucune annonce pour le moment.",
        papers: "Articles",
        no_papers: "Aucun article trouvé pour ce membre.",
        paper_title_fallback: "Sans titre",
        more: "plus...",
        less: "moins...",
        download_pdf: "Télécharger le PDF",
        download: "Télécharger",
        open_link: "Ouvrir le lien",
        edit: "Modifier",
        delete: "Supprimer",
        views_count: "{{count}} vues",
        connected_toast_title: "Connecté",
        connected_toast_desc: "Vous suivez maintenant ce membre.",
        connect_error_title: "Impossible de se connecter",
        connect_error_desc: "Veuillez réessayer plus tard.",
        missing_doc_id: "ID du document manquant",
        confirm_delete: 'Supprimer "{{title}}" ? Cette action est irréversible.',
        paper_deleted: "Article supprimé",
        paper_delete_error: "Impossible de supprimer l'article",
        banner_alt: "Bannière",
        link_icon_alt: "Icône {{label}}",
        thumbnail_alt: "vignette",
        link_website: "Site web",
        link_scholar: "Scholar",
        this_paper: "ce document",
        post_body_missing: "Aucun texte fourni pour cette publication.",
      },
      themes: {
  market_analysis: "Analyse des marchés mondiaux et domestiques, compétitivité et commerce",
  marketing_branding: "Marketing, image de marque et publicité",
  sensory_psychology: "Sensorialité, psychologie du consommateur et linguistique",
  sustainability_climate: "Durabilité, climat et transitions environnementales",
  innovation_tech_digital: "Innovation, technologie et transformation numérique",
  governance_strategy: "Gouvernance, stratégie et modèles d’affaires",
  finance_investment: "Finance, investissement et gestion des risques",
  human_capital: "Capital humain, travail et capacités des entreprises",
  wine_tourism: "Œnotourisme, hospitalité et arts culinaires",
  landscape_territory: "Paysage, développement territorial et écosystèmes régionaux",
  history_culture: "Histoire, culture, patrimoine et valeur symbolique du vin",
  regulation_policy: "Régulation, politiques et cadres institutionnels",
  supply_chain: "Chaîne logistique et distribution",
  social_sustainability: "Durabilité sociale, éthique et droits des travailleurs",
  education_training: "Formation au vin, formation professionnelle et transfert de connaissances",
},
     survey: {
       profile_title: "Profil de l'enquête",
       benchmark_title: "Comparaison avec les pairs",
       cohort_country: "Pays",
       cohort_region: "Région",
       cohort_all: "Tous les répondants",
       h01_region: "Région",
       h02_year_founded: "Fondée en",
       h03_company_type: "Type d'entreprise",
       h04_annual_production_liters: "Production annuelle (L)",
       h05_harvest_method: "Vendange",
       h06_uses_commercial_yeasts: "Levures commerciales",
       h07_has_premium_line: "Gamme premium",
       h08_closures: "Bouchage utilisé",
       h09_exports: "Exportations",
       h10_export_volume_pct: "% du volume exporté",
       h11_export_countries_count: "Pays d'export",
       h12_price_segments: "Segments de prix",
       h13_planner_vs_improviser: "Style",
       yes: "Oui",
       no: "Non",
     },
      weekly_summary: {
        title: "Cette semaine dans le vin",
        week_label: "Semaine {{week}}, {{year}}",
        dismiss: "Masquer jusqu'à la semaine prochaine",
        journal_tab: "Business",
        academic_tab: "Académique",
        policy_tab: "Politique",
      },
    },
  },
  es: {
    common: {
      countries: {
  france: "Francia",
  spain: "España",
  united_states: "Estados Unidos",
  switzerland: "Suiza",
  germany: "Alemania",
  italy: "Italia",
  australia: "Australia",
  croatia: "Croacia",
  chile: "Chile",
},

      app_title: "Una red global para los negocios e investigación del vino",
      landing: {
        explore: "Explorar",
        join: "Unirse",
        explore_observatory: "Explorar el Observatorio",
        sign_in: "Iniciar sesión",
        welcome_back: "Bienvenido de nuevo al instituto.",
        inside_network: "Dentro de la red",
        everything: "Todo lo que reúne el instituto.",
        live_community: "En vivo desde la comunidad",
        newswire: "Noticias del vino",
        latest_journals: "Lo último de las revistas",
        upcoming: "Próximamente",
        vw_eyebrow: "Visualising Wine — para responsables políticos, empresas y académicos",
        vw_heading: "Explora los datos, lee los relatos climáticos, compara cualquier país.",
        vw_sub: "Una base de evidencia para responsables políticos, empresas y académicos — descriptiva, con fuentes y citable.",
        vw_card1_tag: "Explorar",
        vw_card1_title: "El Atlas interactivo",
        vw_card1_desc: "Cada bodega en un mapa — por clima, variedad, exportaciones, terruño y más.",
        vw_card2_tag: "Relato",
        vw_card2_title: "Tres décadas de calentamiento",
        vw_card2_desc: "Desplázate y observa cómo 5106 viñedos se calientan entre los años 1980 y hoy.",
        vw_card3_tag: "Herramienta",
        vw_card3_title: "Retrato de país",
        vw_card3_desc: "Elige un país y compáralo con sus pares, cara a cara.",
        explore_data: "Explorar los datos",
        data_heading: "La primera panorámica mundial, a nivel de empresa, de cómo el mundo elabora vino.",
        data_sub: "21 países productores de vino, estudiados bodega por bodega — exportaciones, cuota ecológica, premiumización y clima. Previsualiza algunos abajo o abre el atlas interactivo.",
        map_alt: "Los 21 países de la encuesta vitivinícola",
        map_text: "Los 21 países productores de vino en un solo mapa interactivo — coloréalo por exportaciones, cuota ecológica, premiumización o clima y explora cada país.",
        open_atlas: "Abrir el atlas interactivo",
        country_portrait: "Retrato de país",
        gate_text: "Mostrando {{n}} de {{total}} países — crea una cuenta gratuita para desbloquear todos los retratos de países, las comparaciones directas y todas las herramientas de investigación.",
        gate_cta: "Crear una cuenta gratuita",
        no_account: "¿Nuevo por aquí?",
        verify_checking: "Confirmando tu correo…",
        verify_ok_title: "Correo confirmado",
        verify_ok_desc: "Tu correo está verificado. Ya puedes iniciar sesión en tu cuenta.",
        verify_bad_title: "Enlace no válido o caducado",
        verify_bad_desc: "Este enlace de verificación no es válido o ha caducado. Inicia sesión para solicitar uno nuevo.",
        verify_back: "Volver al inicio de sesión",
        join_institute: "Únete al instituto",
        join_blurb: "Conecta con investigadores, empresas y responsables políticos de todo el mundo — trae una pregunta, usa las herramientas de investigación y participa en seminarios de la comunidad vitivinícola mundial. La encuesta la mantenemos nosotros; los miembros solo la responden.",
        create_free: "Crear una cuenta gratis",
        see_all: "Ver todo",
        more_platform: "Más en la plataforma",
        all_events: "Todos los eventos",

watch_story: "¿Qué es el GWBI?",
founding_members: "Miembros fundadores",
founding_members_heading:
  "Las instituciones que dieron origen al Global Wine Business Institute.",
founding_members_desc:
  "El GWBI nació de la colaboración entre universidades e instituciones de investigación de la comunidad vitivinícola mundial.",
founding_institutions: "Instituciones fundadoras",
visit_institution: "Visitar la institución",
},
      beta_banner:
        "Beta: Esta plataforma está en desarrollo activo. Las funciones pueden cambiar.",
      login: "Entrar",
      register: "Registrarse",
      email: "Correo electrónico",
      password: "Contraseña",
      remember_me: "Recordarme",
      forgot_password: "¿Olvidaste tu contraseña?",
      create_account_cta: "Crear cuenta gratuita",
      news: "Noticias",
      conferences: "Eventos",
      research: "Investigación",
      insights: "Ideas",
      get_started: "Comenzar",
      see_details: "Ver detalles",
      reset_title: "Restablecer tu contraseña",
      reset_desc: "Introduce tu correo. Si existe, te enviaremos un enlace.",
      send_reset: "Enviar enlace",
      cancel: "Cancelar",
      reg_tagline:
        "Donde el vino se une con el conocimiento: Conecta, comparte y crece en el negocio mundial del vino.",
      reg_create_account: "Crea tu cuenta",
      reg_join: "Únete a la comunidad mundial del vino",
      reg_first_name: "Nombre",
      reg_last_name: "Apellido",
      reg_user_type: "Tipo de usuario",
      reg_user_type_researcher: "Académico / Investigador",
      reg_user_type_student: "Estudiante",
      reg_user_type_industry: "Profesional de la industria",
      industry_categories: {
        grape_grower: "Productor de uva",
        wineries: "Bodegas",
        distributors: "Distribuidores",
        retailers: "Minoristas",
        supply_chain_partners: "Socios de la cadena de suministro",
        hospitality: "Hostelería (restaurantes, bares, hoteles…)",
        media_journalism: "Medios y periodismo",
        wine_educators: "Formadores en vino (sommeliers, catadores…)",
      },
      winery_roles: {
        owner: "Propietario/a",
        winemaker: "Winemaker",
        assistant_winemaker: "Winemaker adjunto/a",
        enologist: "Enólogo/a",
        vineyard_manager: "Responsable de viñedo",
        agronomist: "Agrónomo/a",
        cellar_master: "Maestro/a de bodega",
        operations_director: "Director/a de operaciones",
        sales_manager: "Responsable de ventas",
        pr_manager: "Responsable de relaciones públicas",
        marketing_manager: "Responsable de marketing",
        other_complete: "Otro (especificar)",
      },
      reg_user_type_policy: "Responsable político y cargo público",
      reg_user_type_enthusiast: "Entusiasta",
      reg_user_type_other: "Otro",
      reg_other_specify: "Especifique",
      reg_account_kind: "¿De quién es este perfil?",
      reg_account_kind_individual: "Mío — una persona",
      reg_account_kind_individual_hint:
        "El perfil lleva su propio nombre y aparece en el directorio de personas. Su universidad o empleador sigue mostrándose en su ficha: elija esta opción aunque se registre con una dirección de trabajo.",
      reg_account_kind_organization: "De una institución o empresa que represento",
      reg_account_kind_organization_hint:
        "El perfil lleva el nombre y el logotipo de la organización y se publica como institución. Elija esta opción solo si está creando la página propia de la organización.",
      reg_org_heading: "Su organización",
      reg_org_optional_hint: "Opcional — nos ayuda a enviar la investigación y las invitaciones adecuadas a su organización.",
      reg_org_name: "Nombre de la organización",
      reg_org_type: "Tipo de organización",
      reg_org_type_winery: "Bodega / Finca vitivinícola / Cooperativa",
      reg_org_type_trade: "Comercio, logística y cadena de suministro",
      reg_org_type_university: "Universidad / Instituto de investigación",
      reg_org_type_association: "Consejo regulador y asociación sectorial",
      reg_org_type_government: "Organismo gubernamental / internacional / ONG",
      reg_org_type_other: "Otro",
      reg_error_account_kind: "Indique de quién es este perfil",
      reg_error_org_name: "Introduzca el nombre de su organización",
      reg_error_org_type: "Elija el tipo de organización",
      reg_error_specify: "Especifique",
      reg_step_email: "Email",
      reg_step_info: "Información",
      reg_step_type: "Tipo",
      reg_step_region: "Región",
      reg_step_topics: "Temas",
      reg_email_intro: "Comencemos con tu dirección de email. Verificaremos si está disponible.",
      reg_checking_email: "Verificando disponibilidad…",
      reg_email_available: "¡Este email está disponible!",
      reg_email_taken: "Este email ya está registrado.",
      reg_email_taken_login: "¿Ya tienes una cuenta? Inicia sesión →",
      reg_confirm_password: "Confirmar contraseña",
      reg_passwords_match: "Las contraseñas coinciden",
      reg_passwords_no_match: "Las contraseñas no coinciden",
      reg_pwd_weak: "Débil",
      reg_pwd_fair: "Regular",
      reg_pwd_good: "Buena",
      reg_pwd_strong: "Fuerte",
      reg_pwd_very_strong: "Muy fuerte",
      reg_hide: "Ocultar",
      reg_show: "Mostrar",
      reg_topics_optional: "Opcional — elige los temas que te interesen. Puedes cambiarlos más tarde.",
      reg_describe_role: "Describe tu rol",
      reg_check_inbox_title: "¡Revisa tu bandeja de entrada!",
      reg_check_inbox_desc: "Hemos enviado un email de verificación a:",
      reg_check_inbox_spam: "¿No lo recibiste? Revisa tu carpeta de spam o reenvía.",
      reg_resend_email: "Reenviar email de verificación",
      reg_go_to_login: "Ir al inicio de sesión",
      reg_error_email: "Por favor ingresa un email válido",
      reg_error_first_name: "Por favor ingresa tu nombre",
      reg_error_last_name: "Por favor ingresa tu apellido",
      reg_error_password: "La contraseña debe tener al menos {{min}} caracteres",
      reg_error_password_mismatch: "Las contraseñas no coinciden",
      reg_error_tos: "Por favor acepta los Términos del Servicio",
      reg_error_user_type: "Por favor selecciona un tipo de usuario",
      reg_error_region: "Por favor selecciona una afiliación regional",
      reg_error_generic: "El registro falló. Por favor intenta de nuevo.",
      reg_industry_details: "Detalles de la industria",
      reg_sector_prompt:
        "¿Qué sectores describen tu actividad? (marca todos los que correspondan)",
      reg_work_in_winery: "Trabajo en una bodega",
      reg_winery_roles_prompt:
        "¿Qué roles se aplican a ti? (marca todos los que correspondan)",
      reg_other_role_prompt: 'Si seleccionaste "Otro (completar)", especifica',
      reg_region_label: "Regions",
      reg_north_america: "América del Norte",
      reg_latin_america: "América Latina",
      reg_africa_me: "África y Oriente Medio",
      reg_asia_pacific: "Asia Pacífico",
      reg_western_eu: "Europa occidental y meridional",
      reg_eastern_eu: "Europa oriental y Asia central",
      reg_thematic_discussions: "Temas temáticos",
      reg_loading_topics: "Cargando tus temas guardados…",
      reg_change_later: "Puedes cambiar esto más tarde en tu perfil.",
      reg_password_label: "Contraseña",
      reg_min_characters: "Mínimo {{min}} caracteres",
      reg_accept_terms: "Acepto los",
      reg_terms_link: "Términos del servicio",
      reg_and_the: "y la",
      reg_privacy_link: "Política de privacidad",
      reg_back_button: "Atrás",
      reg_next_button: "Siguiente",
      reg_create_account_button: "Crear cuenta",
      reg_loading_create: "Creando cuenta",
      dashboard: {
        profile_completeness: "Completitud del perfil",
        next: "Siguiente:",
        statistics: "Estadísticas",
        stats: "Estadísticas",
        profile_viewers: "Visitantes del perfil",
        paper_viewers: "Lectores de artículos",
        post_impressions: "Impresiones de publicaciones",
        collections: "Mis selecciones",
        posts: "Posts",
        publications: "Publicaciones",
        notices: "Avisos",
        notice_expires: "Hasta {{date}}",
        notice_open_board: "Abrir el tablón de avisos",
        filters_clear_all: "Borrar todo",
        filters_select_all: "Seleccionar todo",
        connections: "Conexiones",
        connect: "Conectar",
        bookmarks: "Marcadores",
        groups: "Grupos",
        events: "Eventos",
        discussion_boards: "Foros de discusión",
        loading_topics: "Cargando temas…",
        no_topics: "Aún no has seleccionado temas.",
        about_card_info:
          "Esto enlaza a más información sobre el Global Wine Business Institute.",
        show: "Mostrar:",
        show_more: "Mostrar más",
        start_a_post: "Comienza una publicación",
        photo: "Foto",
        video: "Video",
        write_article: "Escribir artículo",
        create_post: "Crear una publicación",
        post_to_anyone: "Publicar para cualquiera",
        remove_media: "Quitar medio",
        post: "Publicar",
        loading_feed: "Cargando feed...",
        no_matches:
          "No hay tarjetas que coincidan con los filtros seleccionados",
        news: "Noticias",
        conferences: "Eventos",
        videos: "Videos",
        article: "Artículo",
        event: "Evento",
        post_label: "Post",
        video_label: "Video",
        watch_video: "Ver video",
        more: "...más",
        date_unknown: "Fecha desconocida",
        insight_prefix: "Idea:",
        member: "Miembro",
        your_name: "Tu nombre",
        notice_board_title: "Tablón de avisos",
      },
      gwbi_team: {
        title: "El equipo GWBI",
        intro: "Las personas que dirigen el Global Wine Business Institute.",
        empty: "El equipo aún no se ha configurado.",
        member_fallback: "Miembro",
      },
      card_view: {
        heading: "Explorar por categoría",
        back_to_dashboard: "Volver al panel",
        description:
          "Elige una categoría para explorar. Las tarjetas son cuadradas y abren enlaces en un visor interno.",
        tab_news: "Noticias",
        tab_events: "Eventos",
        tab_publications: "Publicaciones",
        tab_videos: "Videos",
        search_placeholder:
          "Buscar en noticias, eventos, publicaciones, videos, avisos, perfiles...",
        search_button: "Buscar",
        clear_search: "Limpiar",
        loading: "Cargando…",
        pill_event: "Evento",
        pill_publication: "Publicación",
        pill_news: "Noticias",
        pill_video: "Video",
        insight_label: "Idea:",
        abstract_label: "Resumen:",
        keywords_label: "Palabras clave:",
        read_more: "Leer más...",
        read_less: "Leer menos",
        more: "más",
        show_more: "Mostrar más",
        no_matches_for_search: "No hay coincidencias para esta búsqueda.",
        authors_prefix: "por:",
        sign_up: "Inscribirse",
        modal_title: "Global Wine Business Institute",
        news_logo_alt: "Fuente de noticias",
        publication_logo_alt: "Logotipo de la revista",
        iframe_title: "Detalle",
        tab_notice_board: "Tablón de avisos",
        notice_dm_blocked_title: "Conecta primero",
        notice_dm_blocked_desc: "Envía una solicitud de conexión antes de escribir a este miembro.",
        notice_type_label: "Tipo de aviso:",
        notice_type_all: "Todos los avisos",
        notice_type_coauthor: "Búsquedas de coautor",
        tab_profiles: "Perfiles",
        pill_notice: "Aviso",
        pill_profile: "Perfil",
        notice_posted_by: "Publicado por",
        notice_connect: "Conectar",
        notice_category_collaboration: "Colaboración",
        notice_category_data: "Datos",
        notice_category_student_project: "Proyecto estudiantil",
        notice_category_participation: "Convocatoria de ponencias",
        notice_category_jobs: "Empleos",
        notice_category_opportunity: "Oportunidad académica",
      },
      login_slides: {
        global_reach: {
          title: "Alcance global",
          subtitle: "50.000 bodegas y más de 1.000 investigadores del vino",
        },
        collaboration: {
          title: "Colaboración",
          subtitle: "Investigadores e industria co-crean",
        },
        insights: {
          title: "Ideas",
          subtitle: "Conocimiento, investigación y herramientas para crecer",
        },
        ask_expert: {
          title: "Pregunta a un experto",
          subtitle: "Recibe respuestas de especialistas en todo el mundo",
        },
        reverse_seminars: {
          title: "Seminarios inversos",
          subtitle: "La industria presenta, los investigadores responden",
        },
        weekly_digest: {
          title: "Resumen semanal",
          subtitle: "Esta semana en el negocio del vino",
        },
        winery_data: {
          title: "Datos de bodegas",
          subtitle: "Encuentra datos de 5.300 bodegas en segundos",
        },
        share_research: {
          title: "Compartir investigación",
          subtitle: "Sube artículos y llega a profesionales",
        },
        scholarly_profiles: {
          title: "Perfiles académicos",
          subtitle: "Enlaces ORCID / SSRN / Google Scholar",
        },
        themes: {
          title: "15 temas",
          subtitle: "Del comercio a la sostenibilidad",
        },
        regional_clusters: {
          title: "Clústeres regionales",
          subtitle: "Vistas adaptadas por mercado/región",
        },
        multilingual: {
          title: "Multilingüe",
          subtitle: "EN / FR / ES / IT / DE / PT al lanzamiento",
        },
        smart_curation: {
          title: "Curación inteligente",
          subtitle: "Scraping + PLN + edición humana",
        },
        actionable_insights: {
          title: "Ideas accionables",
          subtitle: "Traducir la investigación en decisiones",
        },
        collaboration_board: {
          title: "Tablero de colaboración",
          subtitle: "Mentoría, proyectos, coautoría",
        },
      },
      right_rail: {
        collaboration: "Colaboración",
        suggested_connections: "Conexiones sugeridas",
        no_suggestions: "Aún no hay sugerencias.",
        upcoming_events: "Próximos eventos",
        no_upcoming_events: "No hay eventos próximos.",
        tba: "Por confirmar",
        untitled_event: "Evento sin título",
        register: "Registrarse",
        current_topics: "Temas actuales en el foro",
        topic_wine_economics:
          "Tendencias del mercado, flujos comerciales y análisis de precios.",
        topic_digital_viticulture:
          "Sensores, teledetección y pipelines de datos del viñedo.",
        topic_fintech_wine:
          "Tokenización, pagos y trazabilidad en blockchain.",
        dataset_tools: "Visualizar el vino",
        vinoverse_title: "El vino en datos",
        vinoverse_subtitle: "Mapas, gráficos e historias sobre datos, políticas e investigación.",
        open: "Abrir",
        industry_reports: "Informes de la industria",
        report_title_market_outlook: "Perspectiva del mercado mundial del vino 2025",
        report_title_logistics: "Benchmark de distribución y logística",
        report_title_sustainability: "Sostenibilidad en el vino 2024",
        report_desc_logistics: "Tiempos de entrega, costes y cuellos de botella",
        report_desc_sustainability: "Adopción de certificaciones y ROI",
        report_desc_market: "Demanda, precios y cambios regionales",
        notice_board: {
          title: "Tablón de avisos",
          subtitle:
            "Convocatorias de datos, colaboraciones, empleos y oportunidades — investigación y sector vitivinícola.",
          cta: "Visitar el tablón",
          add: "Publicar aviso",
          data_calls: { title: "Llamadas a datos / compartir datos" },
          collab_requests: { title: "Solicitudes de colaboración" },
          student_projects: {
            title: "Proyectos estudiantiles / supervisión",
          },
          calls_participation: { title: "Convocatorias de ponencias" },
          jobs: { title: "Empleos" },
          academic_opportunities: { title: "Oportunidades académicas" },
        },
      },
      login_text: {
        email_verified_title: "¡Correo verificado!",
        email_verified_desc: "Tu correo ha sido confirmado correctamente.",
        verification_failed_title: "Verificación fallida",
        verification_failed_desc_fallback: "El enlace es inválido o ha expirado.",
        network_error_title: "Error de red",
        network_error_desc:
          "No se pudo verificar tu correo. Inténtalo de nuevo más tarde.",
        resend_email_required_title: "Correo obligatorio",
        resend_email_required_desc:
          "Ingresa tu correo antes de pedir un nuevo enlace.",
        verification_email_sent_title: "Correo de verificación enviado",
        verification_email_sent_desc: "Revisa tu bandeja de entrada.",
        verification_email_error_title: "No se pudo reenviar la verificación",
        verification_email_error_desc: "Inténtalo de nuevo más tarde.",
        validation_email_required: "Por favor ingresa tu correo",
        validation_password_invalid:
          "Ingresa una contraseña válida (mínimo 6 caracteres)",
        verify_required_message:
          "Primero debes verificar tu correo. Revisa tu bandeja o reenvía el correo de verificación.",
        login_failed_with_detail: "Inicio de sesión fallido: {{detail}}",
        login_failed_default:
          "El correo y/o la contraseña no coinciden con nuestros registros.",
        login_generic_error: "Algo salió mal durante el inicio de sesión.",
        forgot_email_required: "Por favor ingresa tu correo",
        forgot_success:
          "Si la dirección existe en nuestros registros, enviamos un enlace de restablecimiento. Revisa tu correo.",
        forgot_error_with_detail: "No se pudo iniciar el restablecimiento: {{detail}}",
        forgot_error_default:
          "No se pudo iniciar el restablecimiento ahora. Inténtalo más tarde.",
        account_not_verified:
          "Encontramos tu cuenta, pero aún no está verificada.",
        resend_verification_button: "Reenviar correo de verificación",
        loading_news: "Cargando noticias...",
        loading_events: "Cargando eventos...",
        loading_publications: "Cargando publicaciones...",
      },
      top_menu: {
        home: "Inicio",
        gwbi_short: "GWBI",
        gwbi_about: "Acerca del GWBI",
        governance: "Gobernanza",
        founding_members: "Miembros fundadores",
        gwbi_workshops: "Talleres del GWBI",
        contact: "Contáctanos",
        funding_people: "Personas del GWBI",
        funding_academic: "Instituciones académicas",
        funding_partners: "Socios estratégicos",
        funding_industry: "Industria del vino e instituciones",
        themes: "Temas",
        my_network: "Mi red",
        my_world: "Mi Mundo",
        grid: "Colecciones",
        notice_board: "Tablón de avisos",
        profile: "Perfil",
        settings: "Configuración",
        logout: "Cerrar sesión",
        search_placeholder: "Buscar",
        searching: "Buscando…",
        no_results: "No se encontraron resultados.",
        search_failed_default: "La búsqueda falló",
        search_failed_with_status: "La búsqueda falló ({{status}})",
        search_source_people: "Personas",
        search_source_posts: "Publicaciones",
        search_source_documents: "Artículos subidos",
        search_source_publications: "Publicaciones",
        search_source_videos: "Videos",
        search_source_wineries: "Bodegas",
        search_source_other: "{{source}}",
        untitled: "Sin título",
        me: "Yo",
        loading_themes: "Cargando temas…",
        no_themes: "Aún no hay temas disponibles.",
        aria_gwbi_menu: "Menú GWBI",
        aria_regions_menu: "Menú de regiones",
        aria_themes_menu: "Menú de temas",
        aria_language_menu: "Cambiar idioma",
        aria_mobile_menu: "Abrir menú de navegación",
      },
      my_world: {
        heading: "Mi Mundo",
        description: "Tu red, eventos y actividad en un solo lugar.",
        search_placeholder: "Buscar...",
        tab_network: "Mi Red",
        tab_events: "Invitación a eventos",
        tab_feed: "Actividad",
        no_items: "Nada aquí todavía.",
      },
      profile_extern: {
        heading: "Perfil del miembro",
        back_to_dashboard: "Volver al panel",
        loading_profile: "Cargando perfil…",
        no_profile_selected: "Ningún perfil seleccionado",
        member_fallback: "Miembro",
        theme_fallback: "Tema {{id}}",
        connect: "Conectar",
        sign_in_to_connect: "Inicia sesión para conectar",
        block: "Bloquear",
        block_confirm: "¿Bloquear a {{name}}? No podrá escribirte ni enviarte solicitudes, y se eliminará cualquier conexión existente. No se le informará.",
        block_done: "{{name}} ha sido bloqueado",
        block_error: "No se pudo bloquear a este miembro",
        view_profile: "Perfil",
        connecting: "Conectando…",
        connected: "Conectado",
        message: "Mensaje",
        edit_profile: "Editar perfil",
        upload_paper: "+ Subir artículo",
        works_in_winery: "Trabaja en una bodega",
        themes_prefix: "Temas:",
        winery_roles_prefix: "Roles en la bodega:",
        other_role_prefix: "Otro rol:",
        regions_prefix: "Regiones:",
        organization: "Organización",
        country: "País",
        city: "Ciudad",
        member_type: "Tipo de miembro",
        industry_categories: "Categorías de la industria",
        themes: "Temas",
        regions: "Regiones",
        winery_roles: "Roles en la bodega",
        other_winery_role: "Otro rol en la bodega",
        allows_data_sharing: "Permite compartir datos",
        verified_member: "Miembro verificado",
        contact_email: "Correo de contacto",
        yes: "Sí",
        no: "No",
        followers: "Seguidores",
        connections: "Conexiones",
        search_appearances_7d: "Apariciones en búsqueda (7d)",
        profile_details: "Detalles del perfil",
        about: "Acerca de",
        my_posts: "Mis publicaciones",
        no_posts: "Aún no hay publicaciones.",
        no_notices: "Aún no hay avisos.",
        papers: "Artículos",
        no_papers: "No se encontraron artículos para este miembro.",
        paper_title_fallback: "Sin título",
        more: "más...",
        less: "menos...",
        download_pdf: "Descargar PDF",
        download: "Descargar",
        open_link: "Abrir enlace",
        edit: "Editar",
        delete: "Eliminar",
        views_count: "{{count}} vistas",
        connected_toast_title: "Conectado",
        connected_toast_desc: "Ahora sigues a este miembro.",
        connect_error_title: "No se pudo conectar",
        connect_error_desc: "Por favor, inténtalo de nuevo más tarde.",
        missing_doc_id: "ID de documento faltante",
        confirm_delete: '¿Eliminar "{{title}}"? Esto no se puede deshacer.',
        paper_deleted: "Artículo eliminado",
        paper_delete_error: "No se pudo eliminar el artículo",
        banner_alt: "Banner",
        link_icon_alt: "Ícono {{label}}",
        thumbnail_alt: "miniatura",
        link_website: "Sitio web",
        link_scholar: "Scholar",
        this_paper: "este documento",
        post_body_missing: "No hay texto para esta publicación.",
      },
      themes: {
  market_analysis: "Análisis de mercados globales y domésticos, competitividad y comercio",
  marketing_branding: "Marketing, branding y publicidad",
  sensory_psychology: "Sensorialidad, psicología del consumidor y lingüística",
  sustainability_climate: "Sostenibilidad, clima y transiciones ambientales",
  innovation_tech_digital: "Innovación, tecnología y transformación digital",
  governance_strategy: "Gobernanza, estrategia y modelos de negocio",
  finance_investment: "Finanzas, inversión y gestión del riesgo",
  human_capital: "Capital humano, trabajo y capacidades de la empresa",
  wine_tourism: "Enoturismo, hospitalidad y artes culinarias",
  landscape_territory: "Paisaje, desarrollo territorial y ecosistemas regionales",
  history_culture: "Historia, cultura, patrimonio y valor simbólico del vino",
  regulation_policy: "Regulación, políticas y marcos institucionales",
  supply_chain: "Cadena de suministro y distribución",
  social_sustainability: "Sostenibilidad social, ética y derechos laborales",
  education_training: "Educación en vino, formación profesional y transferencia de conocimiento",
},
     survey: {
       profile_title: "Perfil de la encuesta",
       benchmark_title: "Comparación con pares",
       cohort_country: "País",
       cohort_region: "Región",
       cohort_all: "Todos los encuestados",
       h01_region: "Región",
       h02_year_founded: "Fundada en",
       h03_company_type: "Tipo de empresa",
       h04_annual_production_liters: "Producción anual (L)",
       h05_harvest_method: "Vendimia",
       h06_uses_commercial_yeasts: "Levaduras comerciales",
       h07_has_premium_line: "Línea premium",
       h08_closures: "Tipo de cierre",
       h09_exports: "Exportaciones",
       h10_export_volume_pct: "% del volumen exportado",
       h11_export_countries_count: "Países de exportación",
       h12_price_segments: "Segmentos de precio",
       h13_planner_vs_improviser: "Estilo",
       yes: "Sí",
       no: "No",
     },
      weekly_summary: {
        title: "Esta semana en el vino",
        week_label: "Semana {{week}}, {{year}}",
        dismiss: "Ocultar hasta la próxima semana",
        journal_tab: "Negocios",
        academic_tab: "Académico",
        policy_tab: "Política",
      },
    },
  },
  it: {
  common: {
    countries: {
  france: "Francia",
  spain: "Spagna",
  united_states: "Stati Uniti",
  switzerland: "Svizzera",
  germany: "Germania",
  italy: "Italia",
  australia: "Australia",
  croatia: "Croazia",
  chile: "Cile",
},
    app_title: "Una rete globale per il business e la ricerca sul vino",
      landing: {
        explore: "Esplora",
        join: "Unisciti",
        explore_observatory: "Esplora l'Osservatorio",
        sign_in: "Accedi",
        welcome_back: "Bentornato all'istituto.",
        inside_network: "Dentro la rete",
        everything: "Tutto ciò che l'istituto riunisce.",
        live_community: "Dal vivo dalla comunità",
        newswire: "Notizie dal vino",
        latest_journals: "Ultimi dalle riviste",
        upcoming: "In arrivo",
        vw_eyebrow: "Visualising Wine — per decisori, imprese e accademici",
        vw_heading: "Esplora i dati, leggi le storie sul clima, confronta qualsiasi paese.",
        vw_sub: "Una base di evidenze per decisori, imprese e accademici — descrittiva, documentata e citabile.",
        vw_card1_tag: "Esplora",
        vw_card1_title: "L'Atlante interattivo",
        vw_card1_desc: "Ogni cantina su una mappa — per clima, varietà, esportazioni, terroir e altro.",
        vw_card2_tag: "Storia",
        vw_card2_title: "Tre decenni di riscaldamento",
        vw_card2_desc: "Scorri e osserva 5.106 vigneti riscaldarsi tra gli anni '80 e oggi.",
        vw_card3_tag: "Strumento",
        vw_card3_title: "Ritratto di Paese",
        vw_card3_desc: "Scegli un Paese e confrontalo con i suoi pari, testa a testa.",
        explore_data: "Esplora i dati",
        data_heading: "Il primo quadro globale, a livello di impresa, di come il mondo produce vino.",
        data_sub: "21 Paesi produttori di vino, rilevati cantina per cantina — esportazioni, quota biologica, premiumizzazione e clima. Visualizza un'anteprima di alcuni qui sotto o apri l'atlante interattivo.",
        map_alt: "I 21 Paesi dell'indagine vitivinicola",
        map_text: "I 21 Paesi produttori di vino su un'unica mappa interattiva — colora per esportazioni, quota biologica, premiumizzazione o clima ed esplora ogni Paese.",
        open_atlas: "Apri l'atlante interattivo",
        country_portrait: "Ritratto di Paese",
        gate_text: "Anteprima di {{n}} Paesi su {{total}} — crea un account gratuito per sbloccare tutti i ritratti dei Paesi, i confronti diretti e tutti gli strumenti di ricerca.",
        gate_cta: "Crea un account gratuito",
        no_account: "Nuovo qui?",
        verify_checking: "Conferma della tua e-mail…",
        verify_ok_title: "E-mail confermata",
        verify_ok_desc: "La tua e-mail è verificata. Ora puoi accedere al tuo account.",
        verify_bad_title: "Link non valido o scaduto",
        verify_bad_desc: "Questo link di verifica non è valido o è scaduto. Accedi per richiederne uno nuovo.",
        verify_back: "Torna all'accesso",
        join_institute: "Unisciti all'istituto",
        join_blurb: "Connettiti con ricercatori, imprese e decisori di tutto il mondo — porta una domanda, usa gli strumenti di ricerca e partecipa ai seminari della comunità vitivinicola mondiale. L'indagine la manteniamo noi; ai membri basta rispondere.",
        create_free: "Crea un account gratuito",
        see_all: "Vedi tutto",
        more_platform: "Altro sulla piattaforma",
        all_events: "Tutti gli eventi",

watch_story: "Cos'è il GWBI?",
founding_members: "Membri fondatori",
founding_members_heading:
  "Le istituzioni alla base del Global Wine Business Institute.",
founding_members_desc:
  "Il GWBI è nato dalla collaborazione tra università e istituzioni di ricerca della comunità vitivinicola globale.",
founding_institutions: "Istituzioni fondatrici",
visit_institution: "Visita l'istituzione",
},
    beta_banner:
      "Beta: Piattaforma in sviluppo attivo. Le funzionalità possono cambiare.",
    login: "Accedi",
    register: "Registrati",
    email: "Email",
    password: "Password",
    remember_me: "Ricordami",
    forgot_password: "Password dimenticata?",
    create_account_cta: "Crea account gratuito",
    news: "Notizie",
    conferences: "Eventi",
    research: "Ricerca",
    insights: "Insight",
    get_started: "Inizia",
    see_details: "Vedi dettagli",
    reset_title: "Reimposta la password",
    reset_desc: "Inserisci la tua email. Se esiste, invieremo un link.",
    send_reset: "Invia link",
    cancel: "Annulla",

    reg_tagline:
      "Dove il vino incontra la conoscenza — Connettiti, condividi e cresci nel business globale del vino.",
    reg_create_account: "Crea il tuo account",
    reg_join: "Unisciti alla comunità globale del vino",
    reg_first_name: "Nome",
    reg_last_name: "Cognome",
    reg_user_type: "Tipo di utente",
    reg_user_type_researcher: "Accademico / Ricercatore",
    reg_user_type_student: "Studente",
    reg_user_type_industry: "Professionista dell'industria",

    industry_categories: {
      grape_grower: "Viticoltore",
      wineries: "Cantine",
      distributors: "Distributori",
      retailers: "Rivenditori",
      supply_chain_partners: "Partner della supply chain",
      hospitality: "Ospitalità (ristoranti, bar, hotel…)",
      media_journalism: "Media e giornalismo",
      wine_educators: "Formatori del vino (sommelier, degustatori…)",
    },

    winery_roles: {
      owner: "Proprietario/a",
      winemaker: "Winemaker",
      assistant_winemaker: "Assistente winemaker",
      enologist: "Enologo/a",
      vineyard_manager: "Responsabile di vigneto",
      agronomist: "Agronomo/a",
      cellar_master: "Cantiniere / responsabile di cantina",
      operations_director: "Direttore/trice operativo/a",
      sales_manager: "Responsabile vendite",
      pr_manager: "Responsabile PR",
      marketing_manager: "Responsabile marketing",
      other_complete: "Altro (specificare)"
    },

    reg_user_type_policy: "Decisore pubblico e funzionario",
    reg_user_type_enthusiast: "Appassionato",
    reg_user_type_other: "Altro",
    reg_other_specify: "Si prega di specificare",
    reg_account_kind: "Di chi è questo profilo?",
    reg_account_kind_individual: "Mio — una persona",
    reg_account_kind_individual_hint:
      "Il profilo porta il tuo nome e compare nella directory delle persone. La tua università o il tuo datore di lavoro restano visibili sulla scheda: scegli questa opzione anche se ti registri con un indirizzo di lavoro.",
    reg_account_kind_organization: "Di un'istituzione o azienda che rappresento",
    reg_account_kind_organization_hint:
      "Il profilo porta il nome e il logo dell'organizzazione ed è pubblicato come istituzione. Scegli questa opzione solo se stai creando la pagina dell'organizzazione stessa.",
    reg_org_heading: "La tua organizzazione",
    reg_org_optional_hint: "Facoltativo — ci aiuta a inviare le ricerche e gli inviti giusti alla tua organizzazione.",
    reg_org_name: "Nome dell'organizzazione",
    reg_org_type: "Tipo di organizzazione",
    reg_org_type_winery: "Cantina / Tenuta vitivinicola / Cooperativa",
    reg_org_type_trade: "Commercio, logistica e filiera",
    reg_org_type_university: "Università / Istituto di ricerca",
    reg_org_type_association: "Consorzio di tutela e associazione di categoria",
    reg_org_type_government: "Ente governativo / internazionale / ONG",
    reg_org_type_other: "Altro",
    reg_error_account_kind: "Indica di chi è questo profilo",
    reg_error_org_name: "Inserisci il nome della tua organizzazione",
    reg_error_org_type: "Scegli il tipo di organizzazione",
    reg_error_specify: "Si prega di specificare",

    reg_step_email: "Email",
    reg_step_info: "Info",
    reg_step_type: "Tipo",
    reg_step_region: "Regione",
    reg_step_topics: "Argomenti",
    reg_email_intro: "Iniziamo con il tuo indirizzo email. Verificheremo la disponibilità.",
    reg_checking_email: "Verifica in corso…",
    reg_email_available: "Questo indirizzo email è disponibile!",
    reg_email_taken: "Questo indirizzo email è già registrato.",
    reg_email_taken_login: "Hai già un account? Accedi →",
    reg_confirm_password: "Conferma password",
    reg_passwords_match: "Le password corrispondono",
    reg_passwords_no_match: "Le password non corrispondono",
    reg_pwd_weak: "Debole",
    reg_pwd_fair: "Discreta",
    reg_pwd_good: "Buona",
    reg_pwd_strong: "Forte",
    reg_pwd_very_strong: "Molto forte",
    reg_hide: "Nascondi",
    reg_show: "Mostra",
    reg_topics_optional: "Facoltativo — scegli gli argomenti che ti interessano. Puoi cambiarli più tardi.",
    reg_describe_role: "Descrivi il tuo ruolo",
    reg_check_inbox_title: "Controlla la tua casella di posta!",
    reg_check_inbox_desc: "Abbiamo inviato un'email di verifica a:",
    reg_check_inbox_spam: "Non l'hai ricevuta? Controlla lo spam o reinvia.",
    reg_resend_email: "Reinvia email di verifica",
    reg_go_to_login: "Vai al login",
    reg_error_email: "Inserisci un'email valida",
    reg_error_first_name: "Inserisci il tuo nome",
    reg_error_last_name: "Inserisci il tuo cognome",
    reg_error_password: "La password deve avere almeno {{min}} caratteri",
    reg_error_password_mismatch: "Le password non corrispondono",
    reg_error_tos: "Accetta i Termini di Servizio",
    reg_error_user_type: "Seleziona un tipo di utente",
    reg_error_region: "Seleziona un'affiliazione regionale",
    reg_error_generic: "Registrazione fallita. Riprova.",
    reg_industry_details: "Dettagli dell'industria",

    reg_sector_prompt:
      "Quali settori descrivono la tua attività? (seleziona tutti quelli che si applicano)",
    reg_work_in_winery: "Lavoro in una cantina",
    reg_winery_roles_prompt:
      "Quali ruoli si applicano a te? (seleziona tutti quelli che si applicano)",
    reg_other_role_prompt: 'Se hai selezionato "Altro (completa)", specifica',

    reg_region_label: "Regions",
    reg_north_america: "Nord America",
    reg_latin_america: "America Latina",
    reg_africa_me: "Africa e Medio Oriente",
    reg_asia_pacific: "Asia Pacifico",
    reg_western_eu: "Europa occidentale e meridionale",
    reg_eastern_eu: "Europa orientale e Asia centrale",

    reg_thematic_discussions: "Discussioni tematiche",
    reg_loading_topics: "Caricamento dei tuoi temi salvati…",
    reg_change_later: "Puoi cambiarlo più tardi nel tuo profilo.",

    reg_password_label: "Password",
    reg_min_characters: "Minimo {{min}} caratteri",
    reg_accept_terms: "Accetto i",
    reg_terms_link: "Termini di servizio",
    reg_and_the: "e",
    reg_privacy_link: "l'Informativa sulla privacy",

    reg_back_button: "Indietro",
    reg_next_button: "Avanti",
    reg_create_account_button: "Crea account",
    reg_loading_create: "Creazione dell'account",

      dashboard: {
      profile_completeness: "Completezza profilo",
      next: "Prossimo:",
      statistics: "Statistiche",
      stats: "Statistiche",
      profile_viewers: "Visitatori del profilo",
      paper_viewers: "Lettori degli articoli",
      post_impressions: "Impressioni dei post",
      collections: "Le mie scelte",
      posts: "Post",
      publications: "Pubblicazioni",
      notices: "Avvisi",
      notice_expires: "Fino al {{date}}",
      notice_open_board: "Apri la bacheca avvisi",
      filters_clear_all: "Deseleziona tutto",
      filters_select_all: "Seleziona tutto",
      connections: "Connessioni",
      connect: "Connetti",
      bookmarks: "Segnalibri",
      groups: "Gruppi",
      events: "Eventi",
      discussion_boards: "Bacheche di discussione",
      loading_topics: "Caricamento temi…",
      no_topics: "Nessun tema selezionato.",
      about_card_info:
        "Questo rimanda a ulteriori informazioni sul Global Wine Business Institute.",
      show: "Mostra:",
      show_more: "Mostra di più",
      start_a_post: "Avvia un post",
      photo: "Foto",
      video: "Video",
      write_article: "Scrivi un articolo",
      create_post: "Crea un post",
      post_to_anyone: "Pubblica per chiunque",
      remove_media: "Rimuovi media",
      post: "Pubblica",
      loading_feed: "Caricamento feed...",
      no_matches: "Nessuna scheda corrisponde ai filtri selezionati",
      news: "Notizie",
      conferences: "Eventi",
      videos: "Video",
      article: "Articolo",
      event: "Evento",
      post_label: "Post",
      video_label: "Video",
      watch_video: "Guarda il video",
      more: "...altro",
      date_unknown: "Data sconosciuta",
      insight_prefix: "Approfondimento:",
      member: "Membro",
      your_name: "Il tuo nome",
      notice_board_title: "Bacheca avvisi",
    },
    gwbi_team: {
      title: "Il team GWBI",
      intro: "Le persone che guidano il Global Wine Business Institute.",
      empty: "Il team non è ancora stato configurato.",
      member_fallback: "Membro",
    },
    card_view: {
      heading: "Esplora per categoria",
      back_to_dashboard: "Torna alla dashboard",
      description:
        "Scegli una categoria da sfogliare. Le card sono quadrate e aprono i link in un visualizzatore interno.",
        tab_news: "Notizie",
        tab_events: "Eventi",
        tab_publications: "Pubblicazioni",
        tab_videos: "Video",
        search_placeholder:
          "Cerca in notizie, eventi, pubblicazioni, video, avvisi, profili...",
        search_button: "Cerca",
        clear_search: "Pulisci",
        loading: "Caricamento…",
        pill_event: "Evento",
        pill_publication: "Pubblicazione",
        pill_news: "Notizie",
        pill_video: "Video",
        insight_label: "Approfondimento:",
        abstract_label: "Abstract:",
        keywords_label: "Parole chiave:",
        read_more: "Leggi di più...",
        read_less: "Leggi meno",
        more: "altro",
        show_more: "Mostra di più",
        no_matches_for_search: "Nessuna corrispondenza per questa ricerca.",
        authors_prefix: "di:",
        sign_up: "Iscriviti",
        modal_title: "Global Wine Business Institute",
        news_logo_alt: "Fonte di notizie",
        publication_logo_alt: "Logo della rivista",
      iframe_title: "Dettaglio",
      tab_notice_board: "Bacheca avvisi",
      notice_dm_blocked_title: "Collegati prima",
      notice_dm_blocked_desc: "Invia una richiesta di connessione prima di scrivere a questo membro.",
      notice_type_label: "Tipo di avviso:",
      notice_type_all: "Tutti gli avvisi",
      notice_type_coauthor: "Richieste di co-autore",
      tab_profiles: "Profili",
      pill_notice: "Avviso",
      pill_profile: "Profilo",
      notice_posted_by: "Pubblicato da",
      notice_connect: "Connetti",
      notice_category_collaboration: "Collaborazione",
      notice_category_data: "Dati",
      notice_category_student_project: "Progetto studente",
      notice_category_participation: "Call for Papers",
      notice_category_jobs: "Lavoro",
      notice_category_opportunity: "Opportunità accademica",
    },
    right_rail: {
      collaboration: "Collaborazione",
      suggested_connections: "Connessioni suggerite",
      no_suggestions: "Ancora nessun suggerimento.",
      upcoming_events: "Prossimi eventi",
      no_upcoming_events: "Nessun evento in programma.",
      tba: "Da definire",
      untitled_event: "Evento senza titolo",
      register: "Iscriviti",
      current_topics: "Argomenti attuali nel forum",
      topic_wine_economics:
        "Tendenze di mercato, flussi commerciali e analisi dei prezzi.",
      topic_digital_viticulture:
        "Sensori, telerilevamento e pipeline di dati del vigneto.",
      topic_fintech_wine:
        "Tokenizzazione, pagamenti e tracciabilità blockchain.",
      dataset_tools: "Visualizzare il vino",
      vinoverse_title: "Il vino in dati",
      vinoverse_subtitle: "Mappe, grafici e racconti su dati, politiche e ricerca.",
      open: "Apri",
      industry_reports: "Report di settore",
      report_title_market_outlook: "Scenario del mercato del vino 2025",
      report_title_logistics: "Benchmark distribuzione e logistica",
      report_title_sustainability: "Sostenibilità nel vino 2024",
      report_desc_logistics: "Lead time, costi e colli di bottiglia",
        report_desc_sustainability: "Adozione delle certificazioni e ROI",
        report_desc_market: "Domanda, prezzi e cambiamenti regionali",
        notice_board: {
          title: "Bacheca avvisi",
          subtitle:
            "Richieste di dati, collaborazioni, lavoro e opportunità — ricerca e settore vitivinicolo.",
          cta: "Visita la bacheca",
          add: "Pubblica avviso",
          data_calls: { title: "Richieste di dati / condivisione" },
          collab_requests: { title: "Richieste di collaborazione" },
          student_projects: {
            title: "Progetti per studenti / supervisione",
          },
          calls_participation: { title: "Call for Papers" },
          jobs: { title: "Lavoro" },
          academic_opportunities: { title: "Opportunità accademiche" },
        },
      },
    login_slides: {
      global_reach: {
        title: "Portata globale",
        subtitle: "50.000 cantine e oltre 1.000 ricercatori sul vino",
      },
      collaboration: {
        title: "Collaborazione",
        subtitle: "Ricercatori e industria co-creano",
      },
      insights: {
        title: "Insight",
        subtitle: "Conoscenza, ricerca e strumenti per crescere",
      },
      ask_expert: {
        title: "Chiedi a un esperto",
        subtitle: "Ricevi risposte da specialisti in tutto il mondo",
      },
      reverse_seminars: {
        title: "Seminari inversi",
        subtitle: "L'industria presenta, i ricercatori rispondono",
      },
      weekly_digest: {
        title: "Riepilogo settimanale",
        subtitle: "Questa settimana nel business del vino",
      },
      winery_data: {
        title: "Dati delle cantine",
        subtitle: "Trova dati su 5.300 cantine in pochi secondi",
      },
      share_research: {
        title: "Condividi la ricerca",
        subtitle: "Carica articoli e raggiungi i professionisti",
      },
      scholarly_profiles: {
        title: "Profili accademici",
        subtitle: "Link ORCID / SSRN / Google Scholar",
      },
      themes: {
        title: "15 temi",
        subtitle: "Dal commercio alla sostenibilità",
      },
      regional_clusters: {
        title: "Cluster regionali",
        subtitle: "Viste su misura per mercato/regione",
      },
      multilingual: {
        title: "Multilingue",
        subtitle: "EN / FR / ES / IT / DE / PT al lancio",
      },
      smart_curation: {
        title: "Curazione smart",
        subtitle: "Scraping + NLP + redazione umana",
      },
      actionable_insights: {
        title: "Insight azionabili",
        subtitle: "Tradurre la ricerca in decisioni",
      },
      collaboration_board: {
        title: "Board di collaborazione",
        subtitle: "Mentoring, progetti, co‑authorship",
      },
    },
    login_text: {
      email_verified_title: "Email verificata!",
      email_verified_desc: "La tua email è stata confermata con successo.",
      verification_failed_title: "Verifica fallita",
      verification_failed_desc_fallback: "Il link non è valido o è scaduto.",
      network_error_title: "Errore di rete",
      network_error_desc:
        "Impossibile verificare la tua email. Riprova più tardi.",
      resend_email_required_title: "Email richiesta",
      resend_email_required_desc:
        "Inserisci la tua email prima di richiedere un nuovo link.",
      verification_email_sent_title: "Email di verifica inviata",
      verification_email_sent_desc: "Controlla la tua casella di posta.",
      verification_email_error_title: "Impossibile reinviare la verifica",
      verification_email_error_desc: "Riprova più tardi.",
      validation_email_required: "Inserisci la tua email",
      validation_password_invalid:
        "Inserisci una password valida (minimo 6 caratteri)",
      verify_required_message:
        "Devi prima verificare la tua email. Controlla la posta in arrivo o reinvia l'email di verifica.",
      login_failed_with_detail: "Accesso non riuscito: {{detail}}",
      login_failed_default:
        "Email e/o password non corrispondono ai nostri archivi.",
      login_generic_error: "Qualcosa è andato storto durante l'accesso.",
      forgot_email_required: "Inserisci la tua email",
      forgot_success:
        "Se l'indirizzo esiste nei nostri archivi, abbiamo inviato un link di reset. Controlla la tua email.",
      forgot_error_with_detail: "Impossibile avviare il reset: {{detail}}",
      forgot_error_default:
        "Impossibile avviare il reset ora. Riprova più tardi.",
      account_not_verified:
        "Abbiamo trovato il tuo account, ma non è ancora verificato.",
      resend_verification_button: "Reinvia email di verifica",
      loading_news: "Caricamento notizie...",
      loading_events: "Caricamento eventi...",
      loading_publications: "Caricamento pubblicazioni...",
    },
    top_menu: {
      home: "Home",
      gwbi_short: "GWBI",
      gwbi_about: "Informazioni sul GWBI",
      governance: "Governance",
      founding_members: "Membri fondatori",
      gwbi_workshops: "Workshop GWBI",
      contact: "Contattaci",
      funding_people: "Persone GWBI",
      funding_academic: "Istituzioni accademiche",
      funding_partners: "Partner strategici",
      funding_industry: "Industria del vino e istituzioni",
      themes: "Temi",
      my_network: "La mia rete",
      my_world: "Il Mio Mondo",
      grid: "Collezioni",
      notice_board: "Bacheca avvisi",
      profile: "Profilo",
      settings: "Impostazioni",
      logout: "Esci",
      search_placeholder: "Cerca",
      searching: "Ricerca in corso…",
      no_results: "Nessun risultato trovato.",
      search_failed_default: "Ricerca non riuscita",
      search_failed_with_status: "Ricerca non riuscita ({{status}})",
      search_source_people: "Persone",
      search_source_posts: "Post",
      search_source_documents: "Articoli caricati",
      search_source_publications: "Pubblicazioni",
      search_source_videos: "Video",
      search_source_wineries: "Cantine",
      search_source_other: "{{source}}",
      untitled: "Senza titolo",
      me: "Io",
      loading_themes: "Caricamento temi…",
      no_themes: "Nessun tema disponibile al momento.",
      aria_gwbi_menu: "Menu GWBI",
      aria_regions_menu: "Menu regioni",
      aria_themes_menu: "Menu temi",
      aria_language_menu: "Cambia lingua",
      aria_mobile_menu: "Apri menu di navigazione",
    },
    my_world: {
      heading: "Il Mio Mondo",
      description: "La tua rete, eventi e attività in un unico posto.",
      search_placeholder: "Cerca...",
      tab_network: "La Mia Rete",
      tab_events: "Invito agli eventi",
      tab_feed: "Attività",
      no_items: "Niente qui per ora.",
    },
    profile_extern: {
      heading: "Profilo membro",
      back_to_dashboard: "Torna alla dashboard",
      loading_profile: "Caricamento profilo…",
      no_profile_selected: "Nessun profilo selezionato",
      member_fallback: "Membro",
      theme_fallback: "Tema {{id}}",
      connect: "Connetti",
      sign_in_to_connect: "Accedi per connetterti",
      block: "Blocca",
      block_confirm: "Bloccare {{name}}? Non potrà scriverti né inviarti richieste e ogni connessione esistente verrà rimossa. Non riceverà alcuna notifica.",
      block_done: "{{name}} è stato bloccato",
      block_error: "Impossibile bloccare questo membro",
      view_profile: "Profilo",
      connecting: "Connessione…",
      connected: "Connesso",
      message: "Messaggio",
      edit_profile: "Modifica profilo",
      upload_paper: "+ Carica articolo",
      works_in_winery: "Lavora in una cantina",
      themes_prefix: "Temi:",
      winery_roles_prefix: "Ruoli in cantina:",
      other_role_prefix: "Altro ruolo:",
      regions_prefix: "Regioni:",
      organization: "Organizzazione",
      country: "Paese",
      city: "Città",
      member_type: "Tipo di membro",
      industry_categories: "Categorie dell'industria",
      themes: "Temi",
      regions: "Regioni",
      winery_roles: "Ruoli in cantina",
      other_winery_role: "Altro ruolo in cantina",
      allows_data_sharing: "Consente la condivisione dei dati",
      verified_member: "Membro verificato",
      contact_email: "Email di contatto",
      yes: "Sì",
      no: "No",
      followers: "Follower",
      connections: "Connessioni",
      search_appearances_7d: "Apparizioni in ricerca (7g)",
      profile_details: "Dettagli profilo",
      about: "Informazioni",
      my_posts: "I miei post",
      no_posts: "Nessun post al momento.",
      no_notices: "Nessun avviso al momento.",
      papers: "Articoli",
      no_papers: "Nessun articolo trovato per questo membro.",
      paper_title_fallback: "Senza titolo",
      more: "altro...",
      less: "meno...",
      download_pdf: "Scarica PDF",
      download: "Scarica",
      open_link: "Apri il link",
      edit: "Modifica",
      delete: "Elimina",
      views_count: "{{count}} visualizzazioni",
      connected_toast_title: "Connesso",
      connected_toast_desc: "Ora segui questo membro.",
      connect_error_title: "Impossibile connettere",
      connect_error_desc: "Riprova più tardi.",
      missing_doc_id: "ID documento mancante",
      confirm_delete: 'Eliminare "{{title}}"? Questa azione non può essere annullata.',
      paper_deleted: "Articolo eliminato",
      paper_delete_error: "Impossibile eliminare l'articolo",
      banner_alt: "Banner",
      link_icon_alt: "Icona {{label}}",
      thumbnail_alt: "miniatura",
      link_website: "Sito web",
      link_scholar: "Scholar",
      this_paper: "questo documento",
      post_body_missing: "Nessun testo fornito per questo post.",
    },
    themes: {
  market_analysis: "Analisi dei mercati globali e domestici, competitività e commercio",
  marketing_branding: "Marketing, branding e pubblicità",
  sensory_psychology: "Sensorialità, psicologia del consumatore e linguistica",
  sustainability_climate: "Sostenibilità, clima e transizioni ambientali",
  innovation_tech_digital: "Innovazione, tecnologia e trasformazione digitale",
  governance_strategy: "Governance, strategia e modelli di business",
  finance_investment: "Finanza, investimenti e gestione del rischio",
  human_capital: "Capitale umano, lavoro e capacità d’impresa",
  wine_tourism: "Enoturismo, ospitalità e arti culinarie",
  landscape_territory: "Paesaggio, sviluppo territoriale ed ecosistemi regionali",
  history_culture: "Storia, cultura, patrimonio e valore simbolico del vino",
  regulation_policy: "Regolazione, politiche e quadri istituzionali",
  supply_chain: "Supply chain e distribuzione",
  social_sustainability: "Sostenibilità sociale, etica e diritti dei lavoratori",
  education_training: "Formazione sul vino, training professionale e trasferimento di conoscenze",
},
     survey: {
       profile_title: "Profilo dell'indagine",
       benchmark_title: "Confronto con i pari",
       cohort_country: "Paese",
       cohort_region: "Regione",
       cohort_all: "Tutti i rispondenti",
       h01_region: "Regione",
       h02_year_founded: "Anno di fondazione",
       h03_company_type: "Tipo di azienda",
       h04_annual_production_liters: "Produzione annua (L)",
       h05_harvest_method: "Vendemmia",
       h06_uses_commercial_yeasts: "Lieviti commerciali",
       h07_has_premium_line: "Linea premium",
       h08_closures: "Tipo di chiusura",
       h09_exports: "Esportazioni",
       h10_export_volume_pct: "% del volume esportato",
       h11_export_countries_count: "Paesi di esportazione",
       h12_price_segments: "Segmenti di prezzo",
       h13_planner_vs_improviser: "Stile",
       yes: "Sì",
       no: "No",
     },
      weekly_summary: {
        title: "Questa settimana nel vino",
        week_label: "Settimana {{week}}, {{year}}",
        dismiss: "Nascondi fino alla prossima settimana",
        journal_tab: "Business",
        academic_tab: "Accademico",
        policy_tab: "Politica",
      },
  },
},
  de: {
    common: {
      countries: {
  france: "Frankreich",
  spain: "Spanien",
  united_states: "Vereinigte Staaten",
  switzerland: "Schweiz",
  germany: "Deutschland",
  italy: "Italien",
  australia: "Australien",
  croatia: "Kroatien",
  chile: "Chile",
},
      app_title: "Ein globales Netzwerk für Weinwirtschaft und Forschung",
      landing: {
        explore: "Entdecken",
        join: "Beitreten",
        explore_observatory: "Observatorium entdecken",
        sign_in: "Anmelden",
        welcome_back: "Willkommen zurück im Institut.",
        inside_network: "Im Netzwerk",
        everything: "Alles, was das Institut vereint.",
        live_community: "Live aus der Community",
        newswire: "Wein-Nachrichten",
        latest_journals: "Neues aus den Fachzeitschriften",
        upcoming: "Demnächst",
        vw_eyebrow: "Visualising Wine — für Politik, Wirtschaft & Wissenschaft",
        vw_heading: "Daten erkunden, Klimageschichten lesen, Länder vergleichen.",
        vw_sub: "Eine Evidenzbasis für Politik, Wirtschaft und Wissenschaft — deskriptiv, belegt und zitierfähig.",
        vw_card1_tag: "Erkunden",
        vw_card1_title: "Der interaktive Atlas",
        vw_card1_desc: "Jedes Weingut auf einer Karte — nach Klima, Rebsorte, Export, Terroir und mehr.",
        vw_card2_tag: "Reportage",
        vw_card2_title: "Drei Jahrzehnte Erwärmung",
        vw_card2_desc: "Scrollen und mitverfolgen, wie sich 5.106 Weinberge zwischen den 1980ern und heute erwärmen.",
        vw_card3_tag: "Werkzeug",
        vw_card3_title: "Länderporträt",
        vw_card3_desc: "Wählen Sie ein Land und vergleichen Sie es direkt mit anderen.",
        explore_data: "Daten erkunden",
        data_heading: "Das erste globale Bild auf Unternehmensebene davon, wie die Welt Wein erzeugt.",
        data_sub: "21 weinproduzierende Länder, Weingut für Weingut erhoben — Exporte, Bio-Anteil, Premiumisierung und Klima. Sehen Sie unten eine Vorschau oder öffnen Sie den interaktiven Atlas.",
        map_alt: "Die 21 Länder der Weinerhebung",
        map_text: "Alle 21 weinproduzierenden Länder auf einer interaktiven Karte — einfärben nach Exporten, Bio-Anteil, Premiumisierung oder Klima und jedes Land im Detail erkunden.",
        open_atlas: "Interaktiven Atlas öffnen",
        country_portrait: "Länderporträt",
        gate_text: "Vorschau von {{n}} von {{total}} Ländern — erstellen Sie ein kostenloses Konto, um alle Länderporträts, direkte Vergleiche und alle Forschungswerkzeuge freizuschalten.",
        gate_cta: "Kostenloses Konto erstellen",
        no_account: "Neu hier?",
        verify_checking: "E-Mail wird bestätigt…",
        verify_ok_title: "E-Mail bestätigt",
        verify_ok_desc: "Ihre E-Mail ist verifiziert. Sie können sich jetzt in Ihrem Konto anmelden.",
        verify_bad_title: "Link ungültig oder abgelaufen",
        verify_bad_desc: "Dieser Bestätigungslink ist ungültig oder abgelaufen. Melden Sie sich an, um einen neuen anzufordern.",
        verify_back: "Zurück zur Anmeldung",
        join_institute: "Dem Institut beitreten",
        join_blurb: "Vernetzen Sie sich mit Forschenden, Unternehmen und politischen Entscheidungsträgern weltweit — bringen Sie eine Frage mit, nutzen Sie die Forschungswerkzeuge und nehmen Sie an Seminaren der globalen Weingemeinschaft teil. Die Umfrage pflegen wir; Mitglieder beantworten sie einfach.",
        create_free: "Kostenloses Konto erstellen",
        see_all: "Alle ansehen",
        more_platform: "Mehr auf der Plattform",
        all_events: "Alle Veranstaltungen",

watch_story: "Was ist das GWBI?",
founding_members: "Gründungsmitglieder",
founding_members_heading:
  "Die Institutionen hinter dem Global Wine Business Institute.",
founding_members_desc:
  "Das GWBI entstand durch die Zusammenarbeit von Universitäten und Forschungseinrichtungen aus der globalen Weinbranche.",
founding_institutions: "Gründungsinstitutionen",
visit_institution: "Institution besuchen",
},
      beta_banner:
        "Beta: Plattform in aktiver Entwicklung. Funktionen können sich ändern.",
      login: "Anmelden",
      register: "Registrieren",
      email: "E-Mail",
      password: "Passwort",
      remember_me: "Angemeldet bleiben",
      forgot_password: "Passwort vergessen?",
      create_account_cta: "Kostenloses Konto erstellen",
      news: "Neuigkeiten",
      conferences: "Veranstaltungen",
      research: "Forschung",
      insights: "Analysen",
      get_started: "Loslegen",
      see_details: "Details anzeigen",
      reset_title: "Setzen Sie Ihr Passwort zurück",
      reset_desc:
        "Geben Sie Ihre E-Mail ein. Falls sie existiert, senden wir einen Link.",
      send_reset: "Link senden",
      cancel: "Abbrechen",
      reg_tagline:
        "Wo Wein auf Wissen trifft – vernetzen, teilen und wachsen in der Welt des Weinbusiness.",
      reg_create_account: "Erstellen Sie Ihr Konto",
      reg_join: "Treten Sie der globalen Weingemeinschaft bei",
      reg_first_name: "Vorname",
      reg_last_name: "Nachname",
      reg_user_type: "Nutzertyp",
      reg_user_type_researcher: "Wissenschaftler / Forscher",
      reg_user_type_student: "Student:in",
      reg_user_type_industry: "Branchenprofi",
      industry_categories: {
        grape_grower: "Traubenproduzent",
        wineries: "Weingüter",
        distributors: "Distributoren",
        retailers: "Einzelhändler",
        supply_chain_partners: "Partner der Lieferkette",
        hospitality:
          "Gastgewerbe (Restaurants, Bars, Hotels…)",
        media_journalism: "Medien & Journalismus",
        wine_educators:
          "Weinpädagog:innen (Sommeliers, Verkoster:innen…)",
      },
      winery_roles: {
        owner: "Inhaber:in",
        winemaker: "Winemaker",
        assistant_winemaker: "Assistenz-Winemaker",
        enologist: "Önologe / Önologin",
        vineyard_manager: "Weinbergsleiter:in",
        agronomist: "Agronom:in",
        cellar_master: "Kellermeister:in",
        operations_director: "Betriebsleiter:in",
        sales_manager: "Verkaufsleiter:in",
        pr_manager: "PR-Manager:in",
        marketing_manager: "Marketingmanager:in",
        other_complete: "Sonstige (bitte angeben)",
      },
      reg_user_type_policy: "Politischer Entscheidungsträger & Amtsträger",
      reg_user_type_enthusiast: "Weinliebhaber:in",
      reg_user_type_other: "Sonstiges",
      reg_other_specify: "Bitte angeben",
      reg_account_kind: "Für wen ist dieses Profil?",
      reg_account_kind_individual: "Für mich — eine Person",
      reg_account_kind_individual_hint:
        "Das Profil trägt Ihren eigenen Namen und erscheint im Personenverzeichnis. Ihre Universität oder Ihr Arbeitgeber steht weiterhin auf Ihrer Karte — wählen Sie dies auch dann, wenn Sie sich mit einer dienstlichen Adresse registrieren.",
      reg_account_kind_organization: "Für eine Einrichtung oder Firma, die ich vertrete",
      reg_account_kind_organization_hint:
        "Das Profil trägt Namen und Logo der Organisation und wird öffentlich als Einrichtung geführt. Wählen Sie dies nur, wenn Sie die eigene Seite der Organisation anlegen.",
      reg_org_heading: "Ihre Organisation",
      reg_org_optional_hint: "Optional — so erreichen die passenden Forschungsergebnisse und Einladungen Ihre Organisation.",
      reg_org_name: "Name der Organisation",
      reg_org_type: "Art der Organisation",
      reg_org_type_winery: "Weingut / Weinbaubetrieb / Genossenschaft",
      reg_org_type_trade: "Handel, Logistik und Lieferkette",
      reg_org_type_university: "Universität / Forschungsinstitut",
      reg_org_type_association: "Herkunftsschutzrat und Branchenverband",
      reg_org_type_government: "Behörde / Internationale Organisation / NGO",
      reg_org_type_other: "Sonstiges",
      reg_error_account_kind: "Bitte wählen Sie, für wen dieses Profil ist",
      reg_error_org_name: "Bitte den Namen Ihrer Organisation angeben",
      reg_error_org_type: "Bitte die Art der Organisation wählen",
      reg_error_specify: "Bitte angeben",
      reg_step_email: "E-Mail",
      reg_step_info: "Informationen",
      reg_step_type: "Typ",
      reg_step_region: "Region",
      reg_step_topics: "Themen",
      reg_email_intro: "Beginnen wir mit Ihrer E-Mail-Adresse. Wir prüfen die Verfügbarkeit.",
      reg_checking_email: "Verfügbarkeit wird geprüft…",
      reg_email_available: "Diese E-Mail-Adresse ist verfügbar!",
      reg_email_taken: "Diese E-Mail-Adresse ist bereits registriert.",
      reg_email_taken_login: "Haben Sie bereits ein Konto? Anmelden →",
      reg_confirm_password: "Passwort bestätigen",
      reg_passwords_match: "Passwörter stimmen überein",
      reg_passwords_no_match: "Passwörter stimmen nicht überein",
      reg_pwd_weak: "Schwach",
      reg_pwd_fair: "Mäßig",
      reg_pwd_good: "Gut",
      reg_pwd_strong: "Stark",
      reg_pwd_very_strong: "Sehr stark",
      reg_hide: "Verbergen",
      reg_show: "Anzeigen",
      reg_topics_optional: "Optional — wählen Sie Themen, die Sie interessieren. Sie können diese später ändern.",
      reg_describe_role: "Beschreiben Sie Ihre Rolle",
      reg_check_inbox_title: "Prüfen Sie Ihren Posteingang!",
      reg_check_inbox_desc: "Wir haben eine Bestätigungs-E-Mail gesendet an:",
      reg_check_inbox_spam: "Nicht erhalten? Prüfen Sie den Spam-Ordner oder senden Sie erneut.",
      reg_resend_email: "Bestätigungs-E-Mail erneut senden",
      reg_go_to_login: "Zur Anmeldung",
      reg_error_email: "Bitte geben Sie eine gültige E-Mail-Adresse ein",
      reg_error_first_name: "Bitte geben Sie Ihren Vornamen ein",
      reg_error_last_name: "Bitte geben Sie Ihren Nachnamen ein",
      reg_error_password: "Das Passwort muss mindestens {{min}} Zeichen lang sein",
      reg_error_password_mismatch: "Passwörter stimmen nicht überein",
      reg_error_tos: "Bitte akzeptieren Sie die Nutzungsbedingungen",
      reg_error_user_type: "Bitte wählen Sie einen Benutzertyp",
      reg_error_region: "Bitte wählen Sie eine regionale Zugehörigkeit",
      reg_error_generic: "Registrierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
      reg_industry_details: "Branchenangaben",
      reg_sector_prompt:
        "Welche Bereiche beschreiben Ihre Tätigkeit? (Mehrfachauswahl möglich)",
      reg_work_in_winery: "Ich arbeite in einem Weingut",
      reg_winery_roles_prompt:
        "Welche Rollen treffen auf Sie zu? (Mehrfachauswahl möglich)",
      reg_other_role_prompt:
        'Wenn Sie „Sonstige (bitte angeben)“ gewählt haben, präzisieren Sie bitte',
      reg_region_label: "Regions",
      reg_north_america: "Nordamerika",
      reg_latin_america: "Lateinamerika",
      reg_africa_me: "Afrika und Naher Osten",
      reg_asia_pacific: "Asien-Pazifik",
      reg_western_eu: "West- und Südeuropa",
      reg_eastern_eu: "Osteuropa und Zentralasien",
      reg_thematic_discussions: "Thematische Diskussionen",
      reg_loading_topics: "Ihre gespeicherten Themen werden geladen…",
      reg_change_later:
        "Sie können dies später in Ihrem Profil ändern.",
      reg_password_label: "Passwort",
      reg_min_characters: "Mindestens {{min}} Zeichen",
      reg_accept_terms: "Ich akzeptiere die",
      reg_terms_link: "Nutzungsbedingungen",
      reg_and_the: "und die",
      reg_privacy_link: "Datenschutzerklärung",
      reg_back_button: "Zurück",
      reg_next_button: "Weiter",
      reg_create_account_button: "Konto erstellen",
      reg_loading_create: "Konto wird erstellt",
      dashboard: {
        profile_completeness: "Profilvollständigkeit",
        next: "Als Nächstes:",
        statistics: "Statistiken",
        stats: "Statistiken",
        profile_viewers: "Profilbesucher",
        paper_viewers: "Aufrufe von Artikeln",
        post_impressions: "Beitragsaufrufe",
        collections: "Meine Auswahl",
        posts: "Beiträge",
        publications: "Publikationen",
        notices: "Anzeigen",
        notice_expires: "Bis {{date}}",
        notice_open_board: "Schwarzes Brett öffnen",
        filters_clear_all: "Alle abwählen",
        filters_select_all: "Alle auswählen",
        connections: "Kontakte",
        connect: "Vernetzen",
        bookmarks: "Lesezeichen",
        groups: "Gruppen",
        events: "Veranstaltungen",
        discussion_boards: "Diskussionsforen",
        loading_topics: "Themen werden geladen…",
        no_topics: "Derzeit sind keine Themen ausgewählt.",
        about_card_info:
          "Dieser Link führt zu weiteren Informationen über das Global Wine Business Institute.",
        show: "Anzeigen:",
        show_more: "Mehr anzeigen",
        start_a_post: "Einen Beitrag starten",
        photo: "Foto",
        video: "Video",
        write_article: "Artikel schreiben",
        create_post: "Beitrag erstellen",
        post_to_anyone: "An alle posten",
        remove_media: "Medien entfernen",
        post: "Posten",
        loading_feed: "Feed wird geladen...",
        no_matches:
          "Keine Karten entsprechen den ausgewählten Filtern",
        news: "Neuigkeiten",
        conferences: "Veranstaltungen",
        videos: "Videos",
        article: "Artikel",
        event: "Veranstaltung",
        post_label: "Beitrag",
        video_label: "Video",
        watch_video: "Video ansehen",
        more: "...mehr",
        date_unknown: "Datum unbekannt",
        insight_prefix: "Analyse:",
        member: "Mitglied",
        your_name: "Ihr Name",
        notice_board_title: "Schwarzes Brett",
      },
      gwbi_team: {
        title: "Das GWBI-Team",
        intro: "Die Menschen, die das Global Wine Business Institute leiten.",
        empty: "Das Team wurde noch nicht eingerichtet.",
        member_fallback: "Mitglied",
      },
      card_view: {
        heading: "Nach Kategorie entdecken",
        back_to_dashboard: "Zurück zum Dashboard",
        description:
          "Wählen Sie eine Kategorie zum Durchstöbern. Karten sind quadratisch und öffnen Links in einer integrierten Ansicht.",
        tab_news: "Neuigkeiten",
        tab_events: "Veranstaltungen",
        tab_publications: "Publikationen",
        tab_videos: "Videos",
        search_placeholder:
          "Suche in Nachrichten, Veranstaltungen, Publikationen, Videos, Aushängen, Profilen...",
        search_button: "Suchen",
        clear_search: "Zurücksetzen",
        loading: "Laden…",
        pill_event: "Veranstaltung",
        pill_publication: "Publikation",
        pill_news: "Neuigkeiten",
        pill_video: "Video",
        insight_label: "Analyse:",
        abstract_label: "Zusammenfassung:",
        keywords_label: "Schlüsselwörter:",
        read_more: "Mehr lesen...",
        read_less: "Weniger lesen",
        more: "mehr",
        show_more: "Mehr anzeigen",
        no_matches_for_search: "Keine Treffer für diese Suche.",
        authors_prefix: "von:",
        sign_up: "Anmelden",
        modal_title: "Global Wine Business Institute",
        news_logo_alt: "Nachrichtenquelle",
        publication_logo_alt: "Zeitschriftenlogo",
        iframe_title: "Details",
        tab_notice_board: "Schwarzes Brett",
        notice_dm_blocked_title: "Zuerst vernetzen",
        notice_dm_blocked_desc: "Senden Sie eine Vernetzungsanfrage, bevor Sie dieses Mitglied anschreiben.",
        notice_type_label: "Art der Anzeige:",
        notice_type_all: "Alle Anzeigen",
        notice_type_coauthor: "Co-Autor-Gesuche",
        tab_profiles: "Profile",
        pill_notice: "Hinweis",
        pill_profile: "Profil",
        notice_posted_by: "Veröffentlicht von",
        notice_connect: "Vernetzen",
        notice_category_collaboration: "Zusammenarbeit",
        notice_category_data: "Daten",
        notice_category_student_project: "Studierendenprojekt",
        notice_category_participation: "Call for Papers",
        notice_category_jobs: "Stellenangebote",
        notice_category_opportunity: "Akademische Gelegenheit",
      },
      right_rail: {
        collaboration: "Zusammenarbeit",
        suggested_connections: "Vorgeschlagene Kontakte",
        no_suggestions: "Noch keine Vorschläge.",
        upcoming_events: "Bevorstehende Veranstaltungen",
        no_upcoming_events: "Keine bevorstehenden Veranstaltungen.",
        tba: "Noch offen",
        untitled_event: "Unbenannte Veranstaltung",
        register: "Anmelden",
        current_topics: "Aktuelle Themen im Forum",
        topic_wine_economics:
          "Markttrends, Handelsströme und Preisanalyse.",
        topic_digital_viticulture:
          "Sensoren, Fernerkundung und Datenpipelines im Weinberg.",
        topic_fintech_wine:
          "Tokenisierung, Zahlungen und Blockchain‑Nachverfolgung.",
        dataset_tools: "Wein visualisiert",
        vinoverse_title: "Wein in Daten",
        vinoverse_subtitle: "Karten, Diagramme und Geschichten zu Daten, Politik und Forschung.",
        open: "Öffnen",
        industry_reports: "Branchenberichte",
        report_title_market_outlook: "Ausblick Weltweinmarkt 2025",
        report_title_logistics: "Benchmark Distribution & Logistik",
        report_title_sustainability: "Nachhaltigkeit im Wein 2024",
        report_desc_logistics: "Lieferzeiten, Kosten und Engpässe",
        report_desc_sustainability: "Zertifizierungen und ROI",
        report_desc_market: "Nachfrage, Preise und regionale Verschiebungen",
        notice_board: {
          title: "Schwarzes Brett",
          subtitle:
            "Datenaufrufe, Kollaborationen, Stellen und Chancen — aus Forschung und Weinwirtschaft.",
          cta: "Zum Schwarzen Brett",
          add: "Anzeige aufgeben",
          data_calls: { title: "Datenaufrufe / Datenaustausch" },
          collab_requests: { title: "Kooperationsanfragen" },
          student_projects: {
            title: "Studierendenprojekte / Betreuung",
          },
          calls_participation: { title: "Call for Papers" },
          jobs: { title: "Stellenangebote" },
          academic_opportunities: { title: "Akademische Möglichkeiten" },
        },
      },
      login_slides: {
        global_reach: {
          title: "Globale Reichweite",
          subtitle: "50.000 Weingüter und über 1.000 Weinforschende",
        },
        collaboration: {
          title: "Zusammenarbeit",
          subtitle: "Forschende und Industrie co‑kreieren",
        },
        insights: {
          title: "Analysen",
          subtitle: "Wissen, Forschung und Werkzeuge für Wachstum",
        },
        ask_expert: {
          title: "Frag eine Expertin/einen Experten",
          subtitle: "Antworten von Fachleuten weltweit erhalten",
        },
        reverse_seminars: {
          title: "Reverse-Seminare",
          subtitle: "Die Industrie präsentiert, Forschende antworten",
        },
        weekly_digest: {
          title: "Wöchentliche Übersicht",
          subtitle: "Diese Woche im Weinbusiness",
        },
        winery_data: {
          title: "Weingutsdaten",
          subtitle: "Finde Daten zu 5.300 Weingütern in Sekunden",
        },
        share_research: {
          title: "Forschung teilen",
          subtitle: "Lade Papers hoch und erreiche Praktiker",
        },
        scholarly_profiles: {
          title: "Wissenschaftliche Profile",
          subtitle: "ORCID / SSRN / Google Scholar Links",
        },
        themes: {
          title: "15 Themen",
          subtitle: "Von Handel bis Nachhaltigkeit",
        },
        regional_clusters: {
          title: "Regionale Cluster",
          subtitle: "Angepasste Ansichten nach Markt/Region",
        },
        multilingual: {
          title: "Mehrsprachig",
          subtitle: "EN / FR / ES / IT / DE / PT zum Start",
        },
        smart_curation: {
          title: "Smarte Kuration",
          subtitle: "Scraping + NLP + menschliche Redaktion",
        },
        actionable_insights: {
          title: "Handlungsrelevante Analysen",
          subtitle: "Forschung in Entscheidungen übersetzen",
        },
      collaboration_board: {
        title: "Collaboration Board",
        subtitle: "Mentoring, Projekte, Co‑Autorschaft",
      },
    },
      login_text: {
        email_verified_title: "E-Mail verifiziert!",
        email_verified_desc: "Ihre E-Mail wurde erfolgreich bestätigt.",
        verification_failed_title: "Verifizierung fehlgeschlagen",
        verification_failed_desc_fallback: "Der Link ist ungültig oder abgelaufen.",
        network_error_title: "Netzwerkfehler",
        network_error_desc:
          "Ihre E-Mail konnte nicht verifiziert werden. Bitte versuchen Sie es später erneut.",
        resend_email_required_title: "E-Mail erforderlich",
        resend_email_required_desc:
          "Geben Sie Ihre E-Mail an, bevor Sie einen neuen Link anfordern.",
        verification_email_sent_title: "Verifizierungs-E-Mail gesendet",
        verification_email_sent_desc: "Bitte prüfen Sie Ihren Posteingang.",
        verification_email_error_title: "Verifizierung konnte nicht gesendet werden",
        verification_email_error_desc: "Bitte versuchen Sie es später erneut.",
        validation_email_required: "Bitte geben Sie Ihre E-Mail ein",
        validation_password_invalid:
          "Bitte geben Sie ein gültiges Passwort ein (mindestens 6 Zeichen)",
        verify_required_message:
          "Sie müssen zuerst Ihre E-Mail verifizieren. Prüfen Sie Ihr Postfach oder senden Sie die Verifizierung erneut.",
        login_failed_with_detail: "Login fehlgeschlagen: {{detail}}",
        login_failed_default:
          "E-Mail und/oder Passwort stimmen nicht mit unseren Daten überein.",
        login_generic_error: "Beim Login ist ein Fehler aufgetreten.",
        forgot_email_required: "Bitte geben Sie Ihre E-Mail ein",
        forgot_success:
          "Falls die Adresse in unseren Unterlagen existiert, haben wir einen Reset-Link gesendet. Bitte prüfen Sie Ihre E-Mails.",
        forgot_error_with_detail: "Reset konnte nicht gestartet werden: {{detail}}",
        forgot_error_default:
          "Reset konnte jetzt nicht gestartet werden. Bitte versuchen Sie es später erneut.",
        account_not_verified:
          "Wir haben Ihr Konto gefunden, es ist jedoch noch nicht verifiziert.",
        resend_verification_button: "Verifizierungs-E-Mail erneut senden",
        loading_news: "Neuigkeiten werden geladen...",
        loading_events: "Veranstaltungen werden geladen...",
        loading_publications: "Publikationen werden geladen...",
      },
      top_menu: {
        home: "Startseite",
        gwbi_short: "GWBI",
        gwbi_about: "Über das GWBI",
        governance: "Governance",
        founding_members: "Gründungsmitglieder",
        gwbi_workshops: "GWBI-Workshops",
        contact: "Kontakt",
        funding_people: "GWBI-Personen",
        funding_academic: "Akademische Institutionen",
        funding_partners: "Strategische Partner",
      funding_industry: "Weinindustrie und Institutionen",
      themes: "Themen",
      my_network: "Mein Netzwerk",
      my_world: "Meine Welt",
      grid: "Sammlungen",
      notice_board: "Schwarzes Brett",
      profile: "Profil",
      settings: "Einstellungen",
      logout: "Abmelden",
        search_placeholder: "Suchen",
        searching: "Suche…",
        no_results: "Keine Ergebnisse gefunden.",
        search_failed_default: "Suche fehlgeschlagen",
        search_failed_with_status: "Suche fehlgeschlagen ({{status}})",
        search_source_people: "Personen",
        search_source_posts: "Beiträge",
        search_source_documents: "Hochgeladene Artikel",
        search_source_publications: "Publikationen",
        search_source_videos: "Videos",
        search_source_wineries: "Weingüter",
        search_source_other: "{{source}}",
        untitled: "Ohne Titel",
        me: "Ich",
        loading_themes: "Themen werden geladen…",
        no_themes: "Noch keine Themen verfügbar.",
        aria_gwbi_menu: "GWBI-Menü",
        aria_regions_menu: "Regionen-Menü",
        aria_themes_menu: "Themen-Menü",
        aria_language_menu: "Sprache ändern",
        aria_mobile_menu: "Navigationsmenü öffnen",
      },
      my_world: {
        heading: "Meine Welt",
        description: "Dein Netzwerk, Veranstaltungen und Aktivitäten an einem Ort.",
        search_placeholder: "Suchen...",
        tab_network: "Mein Netzwerk",
        tab_events: "Einladung zu Veranstaltungen",
        tab_feed: "Aktivitäten",
        no_items: "Noch nichts hier.",
      },
      profile_extern: {
        heading: "Mitgliederprofil",
        back_to_dashboard: "Zurück zum Dashboard",
        loading_profile: "Profil wird geladen…",
        no_profile_selected: "Kein Profil ausgewählt",
        member_fallback: "Mitglied",
        theme_fallback: "Thema {{id}}",
        connect: "Vernetzen",
        sign_in_to_connect: "Zum Vernetzen anmelden",
        block: "Blockieren",
        block_confirm: "{{name}} blockieren? Diese Person kann Ihnen nicht mehr schreiben oder Anfragen senden, und eine bestehende Verbindung wird entfernt. Sie wird nicht benachrichtigt.",
        block_done: "{{name}} wurde blockiert",
        block_error: "Mitglied konnte nicht blockiert werden",
        view_profile: "Profil",
        connecting: "Verbinden…",
        connected: "Verbunden",
        message: "Nachricht",
        edit_profile: "Profil bearbeiten",
        upload_paper: "+ Paper hochladen",
        works_in_winery: "Arbeitet in einem Weingut",
        themes_prefix: "Themen:",
        winery_roles_prefix: "Rollen im Weingut:",
        other_role_prefix: "Weitere Rolle:",
        regions_prefix: "Regionen:",
        organization: "Organisation",
        country: "Land",
        city: "Stadt",
        member_type: "Mitgliedstyp",
        industry_categories: "Branchenkategorien",
        themes: "Themen",
        regions: "Regionen",
        winery_roles: "Rollen im Weingut",
        other_winery_role: "Weitere Rolle im Weingut",
        allows_data_sharing: "Erlaubt Datenaustausch",
        verified_member: "Verifiziertes Mitglied",
        contact_email: "Kontakt-E-Mail",
        yes: "Ja",
        no: "Nein",
        followers: "Follower",
        connections: "Kontakte",
        search_appearances_7d: "Suchtreffer (7T)",
        profile_details: "Profildetails",
        about: "Über",
        my_posts: "Meine Beiträge",
        no_posts: "Noch keine Beiträge.",
        no_notices: "Noch keine Anzeigen.",
        papers: "Publikationen",
        no_papers: "Keine Publikationen für dieses Mitglied gefunden.",
        paper_title_fallback: "Ohne Titel",
        more: "mehr...",
        less: "weniger...",
        download_pdf: "PDF herunterladen",
        download: "Herunterladen",
        open_link: "Link öffnen",
        edit: "Bearbeiten",
        delete: "Löschen",
        views_count: "{{count}} Aufrufe",
        connected_toast_title: "Verbunden",
        connected_toast_desc: "Sie folgen jetzt diesem Mitglied.",
        connect_error_title: "Verbindung nicht möglich",
        connect_error_desc: "Bitte versuchen Sie es später erneut.",
        missing_doc_id: "Dokument-ID fehlt",
        confirm_delete:
          '"{{title}}" löschen? Dies kann nicht rückgängig gemacht werden.',
        paper_deleted: "Publikation gelöscht",
        paper_delete_error: "Publikation konnte nicht gelöscht werden",
        banner_alt: "Banner",
        link_icon_alt: "{{label}}-Symbol",
        thumbnail_alt: "Vorschaubild",
        link_website: "Webseite",
        link_scholar: "Scholar",
        this_paper: "dieses Dokument",
        post_body_missing: "Kein Text für diesen Beitrag vorhanden.",
      },
      themes: {
  market_analysis: "Analyse globaler und nationaler Märkte, Wettbewerbsfähigkeit und Handel",
  marketing_branding: "Marketing, Markenführung und Werbung",
  sensory_psychology: "Sensorik, Konsumpsychologie und Linguistik",
  sustainability_climate: "Nachhaltigkeit, Klima und ökologische Transformationen",
  innovation_tech_digital: "Innovation, Technologie und digitale Transformation",
  governance_strategy: "Governance, Strategie und Geschäftsmodelle",
  finance_investment: "Finanzen, Investitionen und Risikomanagement",
  human_capital: "Humankapital, Arbeit und Unternehmenskompetenzen",
  wine_tourism: "Weintourismus, Gastgewerbe und kulinarische Künste",
  landscape_territory: "Landschaft, territoriale Entwicklung und regionale Ökosysteme",
  history_culture: "Geschichte, Kultur, Erbe und symbolischer Wert von Wein",
  regulation_policy: "Regulierung, Politik und institutionelle Rahmenbedingungen",
  supply_chain: "Lieferkette und Distribution",
  social_sustainability: "Soziale Nachhaltigkeit, Ethik und Arbeitnehmerrechte",
  education_training: "Weinbildung, berufliche Weiterbildung und Wissenstransfer",
},
     survey: {
       profile_title: "Umfrageprofil",
       benchmark_title: "Vergleich mit Peers",
       cohort_country: "Land",
       cohort_region: "Region",
       cohort_all: "Alle Befragten",
       h01_region: "Region",
       h02_year_founded: "Gründungsjahr",
       h03_company_type: "Unternehmenstyp",
       h04_annual_production_liters: "Jahresproduktion (L)",
       h05_harvest_method: "Ernte",
       h06_uses_commercial_yeasts: "Kommerzielle Hefen",
       h07_has_premium_line: "Premium-Linie",
       h08_closures: "Verschlussart",
       h09_exports: "Exporte",
       h10_export_volume_pct: "Exportanteil (%)",
       h11_export_countries_count: "Exportländer",
       h12_price_segments: "Preissegmente",
       h13_planner_vs_improviser: "Stil",
       yes: "Ja",
       no: "Nein",
     },
      weekly_summary: {
        title: "Diese Woche im Wein",
        week_label: "Woche {{week}}, {{year}}",
        dismiss: "Bis nächste Woche ausblenden",
        journal_tab: "Wirtschaft",
        academic_tab: "Akademisch",
        policy_tab: "Politik",
      },
    },
},
  pt: {
  common: {
    countries: {
  france: "França",
  spain: "Espanha",
  united_states: "Estados Unidos",
  switzerland: "Suíça",
  germany: "Alemanha",
  italy: "Itália",
  australia: "Austrália",
  croatia: "Croácia",
  chile: "Chile",
},
    app_title: "Uma rede global para negócios e pesquisa do vinho",
      landing: {
        explore: "Explorar",
        join: "Aderir",
        explore_observatory: "Explorar o Observatório",
        sign_in: "Entrar",
        welcome_back: "Bem-vindo de volta ao instituto.",
        inside_network: "Dentro da rede",
        everything: "Tudo o que o instituto reúne.",
        live_community: "Ao vivo da comunidade",
        newswire: "Notícias do vinho",
        latest_journals: "Últimas das revistas",
        upcoming: "Em breve",
        vw_eyebrow: "Visualising Wine — para decisores, empresas e académicos",
        vw_heading: "Explore os dados, leia as histórias do clima, compare qualquer país.",
        vw_sub: "Uma base de evidências para decisores, empresas e académicos — descritiva, com fontes e citável.",
        vw_card1_tag: "Explorar",
        vw_card1_title: "O Atlas interativo",
        vw_card1_desc: "Cada vinícola num só mapa — por clima, casta, exportações, terroir e mais.",
        vw_card2_tag: "Reportagem",
        vw_card2_title: "Três décadas de aquecimento",
        vw_card2_desc: "Percorra e veja 5106 vinhas a aquecer entre os anos 1980 e hoje.",
        vw_card3_tag: "Ferramenta",
        vw_card3_title: "Retrato de país",
        vw_card3_desc: "Escolha um país e compare-o com os seus pares, frente a frente.",
        explore_data: "Explorar os dados",
        data_heading: "O primeiro panorama global, ao nível das empresas, de como o mundo faz vinho.",
        data_sub: "21 países produtores de vinho, estudados vinícola a vinícola — exportações, quota biológica, premiumização e clima. Veja uma pré-visualização de alguns abaixo ou abra o atlas interativo.",
        map_alt: "Os 21 países do inquérito vitivinícola",
        map_text: "Os 21 países produtores de vinho num só mapa interativo — colorir por exportações, quota biológica, premiumização ou clima e explorar cada país.",
        open_atlas: "Abrir o atlas interativo",
        country_portrait: "Retrato de país",
        gate_text: "A pré-visualizar {{n}} de {{total}} países — crie uma conta gratuita para desbloquear todos os retratos de países, as comparações diretas e todas as ferramentas de investigação.",
        gate_cta: "Criar uma conta gratuita",
        no_account: "Novo por aqui?",
        verify_checking: "A confirmar o seu e-mail…",
        verify_ok_title: "E-mail confirmado",
        verify_ok_desc: "O seu e-mail está verificado. Já pode iniciar sessão na sua conta.",
        verify_bad_title: "Ligação inválida ou expirada",
        verify_bad_desc: "Esta ligação de verificação é inválida ou expirou. Inicie sessão para solicitar uma nova.",
        verify_back: "Voltar ao início de sessão",
        join_institute: "Aderir ao instituto",
        join_blurb: "Conecte-se com investigadores, empresas e decisores de todo o mundo — traga uma pergunta, use as ferramentas de investigação e participe em seminários da comunidade vitivinícola mundial. O inquérito somos nós que o mantemos; aos membros basta responder.",
        create_free: "Criar uma conta gratuita",
        see_all: "Ver tudo",
        more_platform: "Mais na plataforma",
        all_events: "Todos os eventos",
        watch_story: "O que é o GWBI?",
founding_members: "Membros fundadores",
founding_members_heading:
  "As instituições que deram origem ao Global Wine Business Institute.",
founding_members_desc:
  "O GWBI nasceu da colaboração entre universidades e instituições de pesquisa da comunidade vitivinícola global.",
founding_institutions: "Instituições fundadoras",
visit_institution: "Visitar a instituição",
      },
      
    beta_banner:
      "Beta: Plataforma em desenvolvimento ativo. Funcionalidades podem mudar.",
    login: "Entrar",
    register: "Registrar",
    email: "Email",
    password: "Senha",
    remember_me: "Lembrar-me",
    forgot_password: "Esqueceu a senha?",
    create_account_cta: "Criar conta gratuita",
    news: "Notícias",
    conferences: "Eventos",
    research: "Pesquisa",
    insights: "Insights",
    get_started: "Começar",
    see_details: "Ver detalhes",
    reset_title: "Redefina sua senha",
    reset_desc: "Insira seu e-mail. Se existir, enviaremos um link.",
    send_reset: "Enviar link",
    cancel: "Cancelar",

    reg_tagline:
      "Onde o vinho encontra o conhecimento — Conecte-se, compartilhe e cresça no negócio global do vinho.",
    reg_create_account: "Crie sua conta",
    reg_join: "Junte-se à comunidade global do vinho",
    reg_first_name: "Nome",
    reg_last_name: "Sobrenome",
    reg_user_type: "Tipo de usuário",
    reg_user_type_researcher: "Académico / Investigador",
    reg_user_type_student: "Estudante",
    reg_user_type_industry: "Profissional da indústria",

    industry_categories: {
      grape_grower: "Produtor de uva",
      wineries: "Vinícolas",
      distributors: "Distribuidores",
      retailers: "Varejistas",
      supply_chain_partners: "Parceiros da cadeia de suprimentos",
      hospitality: "Hospitalidade (restaurantes, bares, hotéis…)",
      media_journalism: "Mídia e jornalismo",
      wine_educators: "Educadores de vinho (sommelier, degustadores…)",
    },

    winery_roles: {
      owner: "Proprietário(a)",
      winemaker: "Enólogo(a)",
      assistant_winemaker: "Enólogo(a) assistente",
      enologist: "Enologista",
      vineyard_manager: "Gerente de vinhedo",
      agronomist: "Agrônomo(a)",
      cellar_master: "Mestre de adega",
      operations_director: "Diretor(a) de operações",
      sales_manager: "Gerente de vendas",
      pr_manager: "Gerente de relações públicas",
      marketing_manager: "Gerente de marketing",
      other_complete: "Outro (especificar)",
    },

    reg_user_type_policy: "Decisor político e funcionário público",
    reg_user_type_enthusiast: "Entusiasta",
    reg_user_type_other: "Outro",
    reg_other_specify: "Especifique",
    reg_account_kind: "De quem é este perfil?",
    reg_account_kind_individual: "Meu — uma pessoa",
    reg_account_kind_individual_hint:
      "O perfil tem o seu próprio nome e aparece no diretório de pessoas. A sua universidade ou entidade empregadora continua a constar do seu cartão — escolha esta opção mesmo que se registe com um endereço profissional.",
    reg_account_kind_organization: "De uma instituição ou empresa que represento",
    reg_account_kind_organization_hint:
      "O perfil tem o nome e o logótipo da organização e é listado publicamente como instituição. Escolha esta opção apenas se estiver a criar a página da própria organização.",
    reg_org_heading: "A sua organização",
    reg_org_optional_hint: "Opcional — ajuda-nos a enviar a investigação e os convites certos para a sua organização.",
    reg_org_name: "Nome da organização",
    reg_org_type: "Tipo de organização",
    reg_org_type_winery: "Adega / Quinta vitivinícola / Cooperativa",
    reg_org_type_trade: "Comércio, logística e cadeia de abastecimento",
    reg_org_type_university: "Universidade / Instituto de investigação",
    reg_org_type_association: "Conselho de denominação e associação setorial",
    reg_org_type_government: "Organismo governamental / internacional / ONG",
    reg_org_type_other: "Outro",
    reg_error_account_kind: "Indique de quem é este perfil",
    reg_error_org_name: "Indique o nome da sua organização",
    reg_error_org_type: "Escolha o tipo de organização",
    reg_error_specify: "Especifique",

    reg_step_email: "Email",
    reg_step_info: "Informações",
    reg_step_type: "Tipo",
    reg_step_region: "Região",
    reg_step_topics: "Tópicos",
    reg_email_intro: "Vamos começar com seu endereço de email. Verificaremos a disponibilidade.",
    reg_checking_email: "Verificando disponibilidade…",
    reg_email_available: "Este email está disponível!",
    reg_email_taken: "Este email já está registrado.",
    reg_email_taken_login: "Já tem uma conta? Faça login →",
    reg_confirm_password: "Confirmar senha",
    reg_passwords_match: "As senhas coincidem",
    reg_passwords_no_match: "As senhas não coincidem",
    reg_pwd_weak: "Fraca",
    reg_pwd_fair: "Regular",
    reg_pwd_good: "Boa",
    reg_pwd_strong: "Forte",
    reg_pwd_very_strong: "Muito forte",
    reg_hide: "Ocultar",
    reg_show: "Mostrar",
    reg_topics_optional: "Opcional — escolha os tópicos que te interessam. Você pode alterá-los depois.",
    reg_describe_role: "Descreva sua função",
    reg_check_inbox_title: "Verifique sua caixa de entrada!",
    reg_check_inbox_desc: "Enviamos um email de verificação para:",
    reg_check_inbox_spam: "Não recebeu? Verifique a pasta de spam ou reenvie.",
    reg_resend_email: "Reenviar email de verificação",
    reg_go_to_login: "Ir para login",
    reg_error_email: "Por favor insira um email válido",
    reg_error_first_name: "Por favor insira seu nome",
    reg_error_last_name: "Por favor insira seu sobrenome",
    reg_error_password: "A senha deve ter pelo menos {{min}} caracteres",
    reg_error_password_mismatch: "As senhas não coincidem",
    reg_error_tos: "Por favor aceite os Termos de Serviço",
    reg_error_user_type: "Por favor selecione um tipo de usuário",
    reg_error_region: "Por favor selecione uma afiliação regional",
    reg_error_generic: "O registro falhou. Por favor tente novamente.",
    reg_industry_details: "Detalhes da indústria",

    reg_sector_prompt:
      "Quais setores descrevem sua atividade? (marque todos os que se aplicam)",
    reg_work_in_winery: "Trabalho em uma vinícola",
    reg_winery_roles_prompt:
      "Quais funções se aplicam a você? (marque todas as que se aplicam)",
    reg_other_role_prompt: 'Se selecionou "Outro (completar)", especifique',

    reg_region_label: "Regions",
    reg_north_america: "América do Norte",
    reg_latin_america: "América Latina",
    reg_africa_me: "África e Oriente Médio",
    reg_asia_pacific: "Ásia-Pacífico",
    reg_western_eu: "Europa Ocidental e Meridional",
    reg_eastern_eu: "Europa Oriental e Ásia Central",

    reg_thematic_discussions: "Discussões temáticas",
    reg_loading_topics: "Carregando seus tópicos salvos…",
    reg_change_later: "Você pode alterar isso depois no seu perfil.",

    reg_password_label: "Senha",
    reg_min_characters: "Mínimo de {{min}} caracteres",
    reg_accept_terms: "Eu concordo com os",
    reg_terms_link: "Termos de Serviço",
    reg_and_the: "e a",
    reg_privacy_link: "Política de Privacidade",

    reg_back_button: "Voltar",
    reg_next_button: "Avançar",
    reg_create_account_button: "Criar conta",
    reg_loading_create: "Criando conta…",

    dashboard: {
      profile_completeness: "Completude do perfil",
      next: "Próximo:",
      statistics: "Estatísticas",
      stats: "Estatísticas",
      profile_viewers: "Visitantes do perfil",
      paper_viewers: "Leitores de artigos",
      post_impressions: "Impressões da publicação",
      collections: "Minhas escolhas",
      posts: "Publicações",
      publications: "Publicações",
      notices: "Avisos",
      notice_expires: "Até {{date}}",
      notice_open_board: "Abrir o quadro de avisos",
      filters_clear_all: "Limpar tudo",
      filters_select_all: "Selecionar tudo",
      connections: "Conexões",
      connect: "Conectar",
      bookmarks: "Favoritos",
      groups: "Grupos",
      events: "Eventos",
      discussion_boards: "Fóruns de discussão",
      loading_topics: "Carregando tópicos…",
      no_topics: "Nenhum tópico selecionado ainda.",
      about_card_info:
        "Isto leva a mais informações sobre o Global Wine Business Institute.",
      show: "Mostrar:",
      show_more: "Mostrar mais",
      start_a_post: "Criar uma publicação",
      photo: "Foto",
      video: "Vídeo",
      write_article: "Escrever artigo",
      create_post: "Criar publicação",
      post_to_anyone: "Publicar para todos",
      remove_media: "Remover mídia",
      post: "Publicar",
      loading_feed: "Carregando feed...",
      no_matches: "Nenhum item corresponde aos filtros selecionados",
      news: "Notícias",
      conferences: "Eventos",
      videos: "Vídeos",
      article: "Artigo",
      event: "Evento",
      post_label: "Publicação",
      video_label: "Vídeo",
      watch_video: "Assistir ao vídeo",
      more: "...mais",
      date_unknown: "Data desconhecida",
      insight_prefix: "Insight:",
      member: "Membro",
      your_name: "Seu nome",
      notice_board_title: "Quadro de avisos",
    },
    gwbi_team: {
      title: "A equipa GWBI",
      intro: "As pessoas que dirigem o Global Wine Business Institute.",
      empty: "A equipa ainda não foi configurada.",
      member_fallback: "Membro",
    },
    card_view: {
      heading: "Explorar por categoria",
      back_to_dashboard: "Voltar ao painel",
      description:
        "Escolha uma categoria para navegar. Os cards são quadrados e abrem links em um visualizador interno.",
        tab_news: "Notícias",
        tab_events: "Eventos",
        tab_publications: "Publicações",
        tab_videos: "Vídeos",
        search_placeholder:
          "Pesquisar em notícias, eventos, publicações, vídeos, avisos, perfis...",
        search_button: "Pesquisar",
        clear_search: "Limpar",
        loading: "Carregando…",
        pill_event: "Evento",
        pill_publication: "Publicação",
        pill_news: "Notícias",
        pill_video: "Vídeo",
        insight_label: "Insight:",
        abstract_label: "Resumo:",
        keywords_label: "Palavras-chave:",
        read_more: "Ler mais...",
        read_less: "Ler menos",
        more: "mais",
        show_more: "Mostrar mais",
        no_matches_for_search: "Nenhum resultado para esta pesquisa.",
        authors_prefix: "por:",
        sign_up: "Inscrever-se",
        modal_title: "Global Wine Business Institute",
        news_logo_alt: "Fonte de notícias",
        publication_logo_alt: "Logotipo da revista",
      iframe_title: "Detalhe",
      tab_notice_board: "Quadro de avisos",
      notice_dm_blocked_title: "Conecte-se primeiro",
      notice_dm_blocked_desc: "Envie um pedido de conexão antes de escrever a este membro.",
      notice_type_label: "Tipo de aviso:",
      notice_type_all: "Todos os avisos",
      notice_type_coauthor: "Pedidos de coautoria",
      tab_profiles: "Perfis",
      pill_notice: "Aviso",
      pill_profile: "Perfil",
      notice_posted_by: "Publicado por",
      notice_connect: "Conectar",
      notice_category_collaboration: "Colaboração",
      notice_category_data: "Dados",
      notice_category_student_project: "Projeto estudantil",
      notice_category_participation: "Call for Papers",
      notice_category_jobs: "Vagas",
      notice_category_opportunity: "Oportunidade acadêmica",
    },
    right_rail: {
      collaboration: "Colaboração",
      suggested_connections: "Conexões sugeridas",
      no_suggestions: "Ainda não há sugestões.",
      upcoming_events: "Próximos eventos",
      no_upcoming_events: "Nenhum evento próximo.",
      tba: "A definir",
      untitled_event: "Evento sem título",
      register: "Inscrever-se",
      current_topics: "Tópicos atuais no fórum",
      topic_wine_economics:
        "Tendências de mercado, fluxos comerciais e análise de preços.",
      topic_digital_viticulture:
        "Sensores, sensoriamento remoto e pipelines de dados do vinhedo.",
      topic_fintech_wine:
        "Tokenização, pagamentos e rastreabilidade em blockchain.",
      dataset_tools: "Visualizar o vinho",
      vinoverse_title: "O vinho em dados",
      vinoverse_subtitle: "Mapas, gráficos e histórias sobre dados, políticas e investigação.",
      open: "Abrir",
      industry_reports: "Relatórios do setor",
      report_title_market_outlook: "Perspectiva do mercado de vinho 2025",
      report_title_logistics: "Benchmark de distribuição e logística",
      report_title_sustainability: "Sustentabilidade no vinho 2024",
      report_desc_logistics: "Prazos, custos e gargalos",
      report_desc_sustainability: "Adoção de certificações e ROI",
      report_desc_market: "Demanda, preços e mudanças regionais",
      notice_board: {
        title: "Quadro de avisos",
        subtitle:
          "Chamadas de dados, colaborações, vagas e oportunidades — pesquisa e setor do vinho.",
        cta: "Visitar o quadro",
        add: "Publicar aviso",
        data_calls: { title: "Chamadas de dados / compartilhamento" },
        collab_requests: { title: "Pedidos de colaboração" },
        student_projects: {
          title: "Projetos para estudantes / supervisão",
        },
        calls_participation: { title: "Call for Papers" },
        jobs: { title: "Vagas" },
        academic_opportunities: { title: "Oportunidades acadêmicas" },
      },
    },
    login_slides: {
      global_reach: {
        title: "Alcance global",
        subtitle: "50.000 vinícolas e mais de 1.000 pesquisadores de vinho",
      },
      collaboration: {
        title: "Colaboração",
        subtitle: "Pesquisadores e indústria co‑criam",
      },
      insights: {
        title: "Insights",
        subtitle: "Conhecimento, pesquisa e ferramentas para crescer",
      },
      ask_expert: {
        title: "Pergunte a um especialista",
        subtitle: "Obtenha respostas de especialistas no mundo todo",
      },
      reverse_seminars: {
        title: "Seminários invertidos",
        subtitle: "A indústria apresenta, pesquisadores respondem",
      },
      weekly_digest: {
        title: "Resumo semanal",
        subtitle: "Esta semana no negócio do vinho",
      },
      winery_data: {
        title: "Dados de vinícolas",
        subtitle: "Encontre dados de 5.300 vinícolas em segundos",
      },
      share_research: {
        title: "Compartilhar pesquisa",
        subtitle: "Envie artigos e alcance profissionais",
      },
      scholarly_profiles: {
        title: "Perfis acadêmicos",
        subtitle: "Links ORCID / SSRN / Google Scholar",
      },
      themes: {
        title: "15 temas",
        subtitle: "Do comércio à sustentabilidade",
      },
      regional_clusters: {
        title: "Clusters regionais",
        subtitle: "Visões adaptadas por mercado/região",
      },
      multilingual: {
        title: "Multilíngue",
        subtitle: "EN / FR / ES / IT / DE / PT no lançamento",
      },
      smart_curation: {
        title: "Curadoria inteligente",
        subtitle: "Scraping + PLN + curadoria humana",
      },
      actionable_insights: {
        title: "Insights acionáveis",
        subtitle: "Traduzir pesquisa em decisões",
      },
      collaboration_board: {
        title: "Painel de colaboração",
        subtitle: "Mentoria, projetos, coautoria",
      },
    },
    login_text: {
      email_verified_title: "E-mail verificado!",
      email_verified_desc: "Seu e-mail foi confirmado com sucesso.",
      verification_failed_title: "Falha na verificação",
      verification_failed_desc_fallback: "O link é inválido ou expirou.",
      network_error_title: "Erro de rede",
      network_error_desc:
        "Não foi possível verificar seu e-mail. Tente novamente mais tarde.",
      resend_email_required_title: "E-mail obrigatório",
      resend_email_required_desc:
        "Informe seu e-mail antes de solicitar um novo link.",
      verification_email_sent_title: "E-mail de verificação enviado",
      verification_email_sent_desc: "Verifique sua caixa de entrada.",
      verification_email_error_title: "Não foi possível reenviar a verificação",
      verification_email_error_desc: "Tente novamente mais tarde.",
      validation_email_required: "Por favor, digite seu e-mail",
      validation_password_invalid:
        "Digite uma senha válida (mínimo de 6 caracteres)",
      verify_required_message:
        "Você precisa verificar seu e-mail primeiro. Confira sua caixa de entrada ou reenvie o e-mail de verificação.",
      login_failed_with_detail: "Falha no login: {{detail}}",
      login_failed_default:
        "E-mail e/ou senha não correspondem aos nossos registros.",
      login_generic_error: "Algo deu errado durante o login.",
      forgot_email_required: "Por favor, digite seu e-mail",
      forgot_success:
        "Se o endereço existir em nossos registros, enviamos um link de redefinição. Verifique seu e-mail.",
      forgot_error_with_detail: "Não foi possível iniciar a redefinição: {{detail}}",
      forgot_error_default:
        "Não foi possível iniciar a redefinição agora. Tente novamente mais tarde.",
      account_not_verified:
        "Encontramos sua conta, mas ela ainda não está verificada.",
      resend_verification_button: "Reenviar e-mail de verificação",
      loading_news: "Carregando notícias...",
      loading_events: "Carregando eventos...",
      loading_publications: "Carregando publicações...",
    },
    top_menu: {
      home: "Início",
      gwbi_short: "GWBI",
      gwbi_about: "Sobre o GWBI",
      governance: "Governança",
      founding_members: "Membros fundadores",
      gwbi_workshops: "Workshops do GWBI",
      contact: "Fale conosco",
      funding_people: "Pessoas do GWBI",
      funding_academic: "Instituições acadêmicas",
      funding_partners: "Parceiros estratégicos",
      funding_industry: "Indústria do vinho e instituições",
      themes: "Temas",
      my_network: "Minha rede",
      my_world: "Meu Mundo",
      grid: "Coleções",
      notice_board: "Quadro de avisos",
      profile: "Perfil",
      settings: "Configurações",
      logout: "Sair",
      search_placeholder: "Pesquisar",
      searching: "Pesquisando…",
      no_results: "Nenhum resultado encontrado.",
      search_failed_default: "Falha na pesquisa",
      search_failed_with_status: "Falha na pesquisa ({{status}})",
      search_source_people: "Pessoas",
      search_source_posts: "Publicações",
      search_source_documents: "Artigos enviados",
      search_source_publications: "Publicações",
      search_source_videos: "Vídeos",
      search_source_wineries: "Vinícolas",
      search_source_other: "{{source}}",
      untitled: "Sem título",
      me: "Eu",
      loading_themes: "Carregando temas…",
      no_themes: "Nenhum tema disponível ainda.",
      aria_gwbi_menu: "Menu GWBI",
      aria_regions_menu: "Menu de regiões",
      aria_themes_menu: "Menu de temas",
      aria_language_menu: "Alterar idioma",
      aria_mobile_menu: "Abrir menu de navegação",
    },
    my_world: {
      heading: "Meu Mundo",
      description: "Sua rede, eventos e atividades em um só lugar.",
      search_placeholder: "Pesquisar...",
      tab_network: "Minha Rede",
      tab_events: "Convite para eventos",
      tab_feed: "Atividades",
      no_items: "Nada aqui ainda.",
    },
    profile_extern: {
      heading: "Perfil do membro",
      back_to_dashboard: "Voltar ao painel",
      loading_profile: "Carregando perfil…",
      no_profile_selected: "Nenhum perfil selecionado",
      member_fallback: "Membro",
      theme_fallback: "Tema {{id}}",
      connect: "Conectar",
      sign_in_to_connect: "Entre para se conectar",
      block: "Bloquear",
      block_confirm: "Bloquear {{name}}? Esta pessoa não poderá enviar mensagens nem pedidos, e qualquer conexão existente será removida. Não será informada.",
      block_done: "{{name}} foi bloqueado",
      block_error: "Não foi possível bloquear este membro",
      view_profile: "Perfil",
      connecting: "Conectando…",
      connected: "Conectado",
      message: "Mensagem",
      edit_profile: "Editar perfil",
      upload_paper: "+ Enviar artigo",
      works_in_winery: "Trabalha em uma vinícola",
      themes_prefix: "Temas:",
      winery_roles_prefix: "Funções na vinícola:",
      other_role_prefix: "Outra função:",
      regions_prefix: "Regiões:",
      organization: "Organização",
      country: "País",
      city: "Cidade",
      member_type: "Tipo de membro",
      industry_categories: "Categorias da indústria",
      themes: "Temas",
      regions: "Regiões",
      winery_roles: "Funções na vinícola",
      other_winery_role: "Outra função na vinícola",
      allows_data_sharing: "Permite compartilhamento de dados",
      verified_member: "Membro verificado",
      contact_email: "E-mail de contato",
      yes: "Sim",
      no: "Não",
      followers: "Seguidores",
      connections: "Conexões",
      search_appearances_7d: "Aparições na busca (7d)",
      profile_details: "Detalhes do perfil",
      about: "Sobre",
      my_posts: "Minhas publicações",
      no_posts: "Nenhuma publicação ainda.",
      no_notices: "Nenhum aviso ainda.",
      papers: "Artigos",
      no_papers: "Nenhum artigo encontrado para este membro.",
      paper_title_fallback: "Sem título",
      more: "mais...",
      less: "menos...",
      download_pdf: "Baixar PDF",
      download: "Baixar",
      open_link: "Abrir link",
      edit: "Editar",
      delete: "Excluir",
      views_count: "{{count}} visualizações",
      connected_toast_title: "Conectado",
      connected_toast_desc: "Você agora segue este membro.",
      connect_error_title: "Não foi possível conectar",
      connect_error_desc: "Tente novamente mais tarde.",
      missing_doc_id: "ID do documento ausente",
      confirm_delete: 'Excluir "{{title}}"? Isso não pode ser desfeito.',
      paper_deleted: "Artigo excluído",
      paper_delete_error: "Não foi possível excluir o artigo",
      banner_alt: "Banner",
      link_icon_alt: "Ícone {{label}}",
      thumbnail_alt: "miniatura",
      link_website: "Site",
      link_scholar: "Scholar",
      this_paper: "este documento",
      post_body_missing: "Nenhum texto fornecido para esta publicação.",
    },
    themes: {
  market_analysis: "Análise dos mercados globais e domésticos, competitividade e comércio",
  marketing_branding: "Marketing, branding e publicidade",
  sensory_psychology: "Sensorialidade, psicologia do consumidor e linguística",
  sustainability_climate: "Sustentabilidade, clima e transições ambientais",
  innovation_tech_digital: "Inovação, tecnologia e transformação digital",
  governance_strategy: "Governança, estratégia e modelos de negócio",
  finance_investment: "Finanças, investimento e gestão de riscos",
  human_capital: "Capital humano, trabalho e capacidades das empresas",
  wine_tourism: "Enoturismo, hospitalidade e artes culinárias",
  landscape_territory: "Paisagem, desenvolvimento territorial e ecossistemas regionais",
  history_culture: "História, cultura, património e valor simbólico do vinho",
  regulation_policy: "Regulação, políticas e quadros institucionais",
  supply_chain: "Cadeia de abastecimento e distribuição",
  social_sustainability: "Sustentabilidade social, ética e direitos laborais",
  education_training: "Educação em vinho, formação profissional e transferência de conhecimento",
},
     survey: {
       profile_title: "Perfil da pesquisa",
       benchmark_title: "Comparação com pares",
       cohort_country: "País",
       cohort_region: "Região",
       cohort_all: "Todos os respondentes",
       h01_region: "Região",
       h02_year_founded: "Ano de fundação",
       h03_company_type: "Tipo de empresa",
       h04_annual_production_liters: "Produção anual (L)",
       h05_harvest_method: "Colheita",
       h06_uses_commercial_yeasts: "Leveduras comerciais",
       h07_has_premium_line: "Linha premium",
       h08_closures: "Tipo de vedação",
       h09_exports: "Exportações",
       h10_export_volume_pct: "% do volume exportado",
       h11_export_countries_count: "Países de exportação",
       h12_price_segments: "Segmentos de preço",
       h13_planner_vs_improviser: "Estilo",
       yes: "Sim",
       no: "Não",
     },
      weekly_summary: {
        title: "Esta semana no vinho",
        week_label: "Semana {{week}}, {{year}}",
        dismiss: "Ocultar até a próxima semana",
        journal_tab: "Negócios",
        academic_tab: "Acadêmico",
        policy_tab: "Política",
      },
  },
},

};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    // Namespaces: we’ll use "common" everywhere
    ns: ["common"],
    defaultNS: "common",
    fallbackLng: "en", // English default
    interpolation: { escapeValue: false },
    detection: {
      // Auto-detect & persist:
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lang",
      caches: ["localStorage"],
    },
  });

// Keep <html lang="xx"> in sync for accessibility/SEO
i18n.on("languageChanged", (lng) => {
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("lang", lng);
  }
});

export default i18n;
